import {
  DatePicker,
  Collapse,
  Select,
  Button,
  Radio,
  Table,
  Modal,
  Form,
  Input,
  InputNumber,
  Switch,
  Space,
  Typography,
  Flex,
  Checkbox,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import styles from "./styles.module.css";
import { BreathAPIs } from "../../APIs/BreathAPIs";
import { toast } from "react-toastify";

const { Title } = Typography;
const { Panel } = Collapse;
// const { Option } = Select;

const CreateBid = ({
  selectedDeal,
  setShowBidCreateModel,
  showBidCreateModel,
  email,
  phone,
  editBid = false,
  bidData = null,
  getDealBids = null,
}) => {
  // console.log("editBid", editBid, bidData);

  let defaultItems = {
    l2Charger: {
      title: "Level 2 Charging Station",
      description:
        "L2 AC EV Charger (Capacity for up to 11.5kW - Charges at up to ~40 mi/hr; max speed is vehicle dependent)",
      unit_price: 850.0,
      quantity: 1,
      margin: 0.0,
      salesTaxApplicable: false,
      salesTaxPercent: 0,
    },
    l3Charger: {
      title: "Level 3 Charging Station",
      description:
        "60 kW Level 3 Charger Station - Wallbox Supernova 60kW Dual Port DC Fast Charger",
      unit_price: 61000.0,
      quantity: 1,
      margin: 0.0,
      salesTaxApplicable: false,
      salesTaxPercent: 0,
    },
    electricalWork: {
      title: "Electrical System Infrastructure and Charger Installation",
      description:
        "Includes all parts, materials, labor and any upgrades to electrical system [if necessary] to support the install of new EV chargers",
      unit_price: 2500.0,
      quantity: 1,
      margin: 0.0,
      salesTaxApplicable: false,
      salesTaxPercent: 0,
    },
    wifiConnectivity: {
      title: "BreatheEV Network Connectivity",
      description:
        "5-Year Connectivity to BreatheEV Charging Network subject to operating agreement",
      unit_price: 0.0,
      quantity: 1,
      margin: 0.0,
      salesTaxApplicable: false,
      salesTaxPercent: 0,
    },
    wifiAntenna: {
      title: "WiFi Antenna and Connectivity Plan",
      description:
        "Wi-Fi Antenna, Mounting Kit with Lock and Connectivity Plan for 5-Years",
      unit_price: 799.0,
      quantity: 1,
      margin: 104.0,
      salesTaxApplicable: false,
      salesTaxPercent: 0,
    },
    warranty: {
      title: "Charger Warranty",
      description:
        "5 Year Warranty on charger unit",
      unit_price: 0.0,
      quantity: 1,
      margin: 0.0,
      salesTaxApplicable: false,
      salesTaxPercent: 0,
    },
    shipping: {
      title: "Shipping & Handling",
      description: "",
      unit_price: 0.0,
      quantity: 1,
      margin: 0.0,
      salesTaxApplicable: false,
      salesTaxPercent: 0,
    },
    signage: {
      title: "Signage",
      description: "EV charging station signage with QR code",
      unit_price: 60.0,
      quantity: 1,
      margin: 65.0,
      salesTaxApplicable: false,
      salesTaxPercent: 0,
    },
    pedestals: {
      title: "Pedestal",
      description: "Charging station pedestal and mounting hardware",
      unit_price: 400.0,
      quantity: 1,
      margin: 0.0,
      salesTaxApplicable: false,
      salesTaxPercent: 0,
    },
    simCard4G: {
      title: "4G Multi-network SIM Card and Data Plan",
      description: "SIM Card with 5 year LTE data connectivity plan",
      unit_price: 453.0,
      quantity: 1,
      margin: 0.0,
      salesTaxApplicable: false,
      salesTaxPercent: 0,
    },
    siteWiFi: {
      title: "Wi-Fi provided by Property",
      description: "Property responsible for providing Wi-Fi. Dedicated 2.4GHz network is strongly recommended. Minimum signal strength of -60 dBm or better at charger.",
      unit_price: 0.0,
      quantity: 1,
      margin: 0.0,
      salesTaxApplicable: false,
      salesTaxPercent: 0,
    },
    chargerInstallOnly: {
      title: "EV Charger Installation",
      description: "EV charger installation and commissioning only. Conduit, wiring to stub-up and panel capacity assumed in place. This proposal does not cover any electrical infrastructure work beyond the stub-up point.",
      unit_price: 2000.0,
      quantity: 1,
      margin: 0.0,
      salesTaxApplicable: false,
      salesTaxPercent: 0,
    },
  };
  let currentDate = new Date();

  // add 1 month
  currentDate.setMonth(currentDate.getMonth() + 1);

  // format as MM/DD/YYYY
  let formattedDate = currentDate.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  let InitialtermsAndConditions = '50% of the invoice total is due upon receipt, prior to initiation of work. The remaining 50% is due upon completion of installation, defined as chargers physically installed, as confirmed by BreatheEV’s written notice of completion. Late payments shall accrue interest at 1.5% per month, or the maximum legal rate, whichever is less, beginning 30 days after the applicable due date: the invoice date for the first payment, and the completion notice date for the second payment. Any discrepancies must be reported within 7 days of the invoice date.'
//   `Payment 1 (50%) due prior to initiation of work. 
// Payment 2 (50%) due upon completion of work,
// which is determined as chargers readily
// accessible for use. Proposal valid until ${formattedDate}`;

  let InitialtermsAndConditionsForFullPayment = 'Full payment is due prior to initiation of work or release of materials. Late payments shall accrue interest at 1.5% per month, or the maximum legal rate, whichever is less, beginning 30 days after the invoice date. Any discrepancies must be reported within 7 days of the invoice date.'
  // `Payment due prior to initiation of work. Proposal valid until ${formattedDate}`;

  let InitialcustomDescription = `*SRP Customers are eligible for rebates of up to 
$ XYZ per port for removal and replacement of old EV 
charging hardware. BreatheEV will assist in application 
and final submission of information for rebate 
disbursement. 
The property can receive up to $ XYZ post-install 
resulting in a effective total cost of as low as $ XYZ for 
the project.`;

  const [form] = Form.useForm();
  // console.log("Selected Deal: ", selectedDeal);
  // console.log("edit bid: ", editBid, bidData?.rebateTitle)
  const [rebateChecked, setRebateChecked] = useState(!editBid ? false : bidData?.rebateTitle ? true : false);

  const handleRebateChange = (checked) => {
    setRebateChecked(checked);
    if (checked) {
      setNewBidData({
        ...newBidData,
        rebateAmount: 0,
        rebateTitle: "SRP REBATE",
      })
    } else {
      let { rebateAmount, rebateTitle, ...updatedBidData } = newBidData
      setNewBidData(updatedBidData)
    }
  };
  const [selectedDefaultItems, setSelectedDefaultItems] = useState(
    !editBid
      ? {
        l2Charger: false,
        l3Charger: false,
        electricalWork: false,
        wifiConnectivity: false,
        wifiAntenna: false,
        warranty: false,
        shipping: false,
        signage: false,
        pedestals: false,
        simCard4G: false,
        siteWiFi: false,
        chargerInstallOnly: false,
        softwareOnly: false
      }
      : {
        l2Charger: bidData?.l2Charger ? true : false,
        l3Charger: bidData?.l3Charger ? true : false,
        electricalWork: bidData?.electricalWork ? true : false,
        wifiConnectivity: bidData?.wifiConnectivity ? true : false,
        wifiAntenna: bidData?.wifiAntenna ? true : false,
        warranty: bidData?.warranty ? true : false,
        shipping: bidData?.shipping ? true : false,
        signage: bidData?.signage ? true : false,
        pedestals: bidData?.pedestals ? true : false,
        simCard4G: bidData?.simCard4G ? true : false,
        siteWiFi: bidData?.siteWiFi ? true : false,
        chargerInstallOnly: bidData?.chargerInstallOnly ? true : false,
        softwareOnly: bidData?.softwareOnly ? true : false
      }
  );
  const [newBidData, setNewBidData] = useState(
    !editBid
      ? {
        termsAndConditions: InitialtermsAndConditionsForFullPayment,
        customDescription: InitialcustomDescription,
        salesTax: 0,
        salesTaxPercent: 0,
        bidCustomData: [],
        email: email ? email : null,
        phone: phone ? phone : null,
        dealPOC: { name: "", email: "", phone: "" },
        paymentType: "FullPayment",
      }
      : bidData
  );
  const [count, setCount] = useState(
    !editBid ? 0 : bidData.bidCustomData.length
  );
  const [subTotalCost, setSubTotalCost] = useState(0);
  const [totalMarginCost, setTotalMarginCost] = useState(0);
  const [totalCostAmount, setTotalCostAmount] = useState(0);

  const CalculateTotalCost = () => {
    let subtotal = 0;
    let totalMargin = 0;
    if (
      newBidData?.l2Charger?.quantity 
      // &&
      // newBidData?.l2Charger?.pricePerUnit
    ) {
      //l2Charger
      subtotal +=
        (newBidData.l2Charger.quantity * (newBidData.l2Charger.pricePerUnit ?? 0) +
        newBidData.l2Charger.margin);
      totalMargin += newBidData.l2Charger.margin;
    }
    if (
      newBidData?.l3Charger?.quantity 
      // &&
      // newBidData?.l3Charger?.pricePerUnit
    ) {
      //l3Charger
      subtotal +=
          newBidData.l3Charger.quantity * (newBidData.l3Charger.pricePerUnit ?? 0) +
          newBidData.l3Charger.margin;
      totalMargin += newBidData.l3Charger.margin;
    }
    if (
      newBidData?.electricalWork?.quantity 
      // &&
      // newBidData?.electricalWork?.pricePerUnit
    ) {
      //electricalWork
      subtotal += 
        newBidData.electricalWork.quantity *
        (newBidData.electricalWork.pricePerUnit ?? 0) +
        newBidData.electricalWork.margin;
      totalMargin += newBidData.electricalWork.margin;
    }
    if (newBidData?.wifiAntenna?.quantity 
      // && newBidData?.wifiAntenna?.pricePerUnit
    ) {
      subtotal +=
        newBidData.wifiAntenna.quantity *
        (newBidData.wifiAntenna.pricePerUnit ?? 0) +
        newBidData.wifiAntenna.margin;
      totalMargin += newBidData.wifiAntenna.margin;
    }
    if (
      newBidData?.wifiConnectivity?.quantity
      //  &&
      // newBidData?.wifiConnectivity?.pricePerUnit
    ) {

      subtotal +=
        newBidData.wifiConnectivity.quantity *
        (newBidData.wifiConnectivity.pricePerUnit ?? 0) +
        newBidData.wifiConnectivity.margin;
      totalMargin += newBidData.wifiConnectivity.margin;
    }
    if (newBidData?.warranty?.quantity 
      //  &&
      // newBidData?.warranty?.pricePerUnit
    ) {
      //warranty
      subtotal +=
        newBidData.warranty.quantity * (newBidData.warranty.pricePerUnit ?? 0) +
        newBidData.warranty.margin;
      totalMargin += newBidData.warranty.margin;
    }
    if (newBidData?.shipping?.quantity 
      // && newBidData?.shipping?.pricePerUnit
    ) {
      //shipping
      subtotal +=
        newBidData.shipping.quantity * (newBidData.shipping.pricePerUnit ?? 0) +
        newBidData.shipping.margin;
      totalMargin += newBidData.shipping.margin;
    }
    if (newBidData?.signage?.quantity 
      // && newBidData?.signage?.pricePerUnit
    ) {
      //signage
      subtotal +=
        newBidData.signage.quantity * (newBidData.signage.pricePerUnit ?? 0) +
        newBidData.signage.margin;
      totalMargin += newBidData.signage.margin;
    }
    if (
      newBidData?.pedestals?.quantity 
      // &&
      // newBidData?.pedestals?.pricePerUnit
    ) {
      //pedestals
      subtotal +=
        newBidData.pedestals.quantity * (newBidData.pedestals.pricePerUnit ?? 0) +
        newBidData.pedestals.margin;
      totalMargin += newBidData.pedestals.margin;
    }
    if (
      newBidData?.simCard4G?.quantity
      //  &&
      // newBidData?.simCard4G?.pricePerUnit
    ) {
      //simCard4G
      subtotal +=
        newBidData.simCard4G.quantity * (newBidData.simCard4G.pricePerUnit ?? 0) +
        newBidData.simCard4G.margin;
      totalMargin += newBidData.simCard4G.margin;
    }
    if (
      newBidData?.siteWiFi?.quantity 
      // &&
      // newBidData?.siteWiFi?.pricePerUnit
    ) {
      //siteWiFi
      subtotal +=
        newBidData.siteWiFi.quantity * (newBidData.siteWiFi.pricePerUnit ?? 0) +
        newBidData.siteWiFi.margin;
      totalMargin += newBidData.siteWiFi.margin;
    }
    if (
      newBidData?.chargerInstallOnly?.quantity 
      // &&
      // newBidData?.chargerInstallOnly?.pricePerUnit
    ) {
      //chargerInstallOnly
      subtotal +=
        newBidData.chargerInstallOnly.quantity * (newBidData.chargerInstallOnly.pricePerUnit ?? 0) +
        newBidData.chargerInstallOnly.margin;
      totalMargin += newBidData.chargerInstallOnly.margin;
    }

    if (newBidData.bidCustomData.length > 0) {
      newBidData.bidCustomData.forEach((item) => {
        if (item?.fieldQuantity 
          // && item?.fieldPricePerUnit
        ) {
          subtotal +=
            item.fieldQuantity * (item.fieldPricePerUnit ?? 0)
            + item.fieldMargin;
          totalMargin += item.fieldMargin;
        }
      });
    }

     
    // console.log("rebate amount: ", newBidData.rebateAmount);
    let totalCost = subtotal + (newBidData.salesTax ? newBidData.salesTax : 0) - (newBidData.rebateAmount ? newBidData.rebateAmount : 0);
    // newBidData.salesTaxPercent = totalCost > 0 ? ((newBidData.salesTax ? newBidData.salesTax : 0) / subtotal) * 100 : 0;
    // console.log("subtotal: ", subtotal);
    // console.log("total margin: ", totalMargin);
    // console.log("total cost: ", totalCost);
    setSubTotalCost(subtotal);
    setTotalCostAmount(totalCost);
    setTotalMarginCost(totalMargin);
  };

  const handleSalesTaxPercentChange = (value, newBidDatavalue) => {
    // console.log("sales tax percent: ", value);
    let totalSalesTax = 0;
    
    let updatedCustomData = newBidDatavalue.bidCustomData ? [...newBidDatavalue.bidCustomData] : [];
    
    if(newBidDatavalue.l2Charger && newBidDatavalue.l2Charger.salesTaxApplicable === true){
      totalSalesTax += ((newBidDatavalue.l2Charger.quantity * newBidDatavalue.l2Charger.pricePerUnit) + newBidDatavalue.l2Charger.margin) * (value / 100);
    }
    if(newBidDatavalue.l3Charger && newBidDatavalue.l3Charger.salesTaxApplicable === true){
      totalSalesTax += ((newBidDatavalue.l3Charger.quantity * newBidDatavalue.l3Charger.pricePerUnit) + newBidDatavalue.l3Charger.margin) * (value / 100);
    }
    if(newBidDatavalue.electricalWork && newBidDatavalue.electricalWork.salesTaxApplicable === true){
      totalSalesTax += ((newBidDatavalue.electricalWork.quantity * newBidDatavalue.electricalWork.pricePerUnit) + newBidDatavalue.electricalWork.margin) * (value / 100);
    }
    if(newBidDatavalue.wifiAntenna && newBidDatavalue.wifiAntenna.salesTaxApplicable === true){
      totalSalesTax += ((newBidDatavalue.wifiAntenna.quantity * newBidDatavalue.wifiAntenna.pricePerUnit) + newBidDatavalue.wifiAntenna.margin) * (value / 100);
    }
    if(newBidDatavalue.wifiConnectivity && newBidDatavalue.wifiConnectivity.salesTaxApplicable === true){
      totalSalesTax += ((newBidDatavalue.wifiConnectivity.quantity * newBidDatavalue.wifiConnectivity.pricePerUnit) + newBidDatavalue.wifiConnectivity.margin) * (value / 100);
    }
    if(newBidDatavalue.warranty && newBidDatavalue.warranty.salesTaxApplicable === true){
      totalSalesTax += ((newBidDatavalue.warranty.quantity * newBidDatavalue.warranty.pricePerUnit) + newBidDatavalue.warranty.margin) * (value / 100);
    }
    if(newBidDatavalue.shipping && newBidDatavalue.shipping.salesTaxApplicable === true){
      totalSalesTax += ((newBidDatavalue.shipping.quantity * newBidDatavalue.shipping.pricePerUnit) + newBidDatavalue.shipping.margin) * (value / 100);
    }
    if(newBidDatavalue.signage && newBidDatavalue.signage.salesTaxApplicable === true){
      totalSalesTax += ((newBidDatavalue.signage.quantity * newBidDatavalue.signage.pricePerUnit) + newBidDatavalue.signage.margin) * (value / 100);
    }
    if(newBidDatavalue.pedestals && newBidDatavalue.pedestals.salesTaxApplicable === true){
      totalSalesTax += ((newBidDatavalue.pedestals.quantity * newBidDatavalue.pedestals.pricePerUnit) + newBidDatavalue.pedestals.margin) * (value / 100);
    }
    if(newBidDatavalue.simCard4G && newBidDatavalue.simCard4G.salesTaxApplicable === true){
      totalSalesTax += ((newBidDatavalue.simCard4G.quantity * newBidDatavalue.simCard4G.pricePerUnit) + newBidDatavalue.simCard4G.margin) * (value / 100);
    }
    if(newBidDatavalue.siteWiFi && newBidDatavalue.siteWiFi.salesTaxApplicable === true){
      totalSalesTax += ((newBidDatavalue.siteWiFi.quantity * newBidDatavalue.siteWiFi.pricePerUnit) + newBidDatavalue.siteWiFi.margin) * (value / 100);
    }
    if(newBidDatavalue.chargerInstallOnly && newBidDatavalue.chargerInstallOnly.salesTaxApplicable === true){
      totalSalesTax += ((newBidDatavalue.chargerInstallOnly.quantity * newBidDatavalue.chargerInstallOnly.pricePerUnit) + newBidDatavalue.chargerInstallOnly.margin) * (value / 100);
    }
    if(newBidDatavalue.bidCustomData && newBidDatavalue.bidCustomData.length > 0){
      updatedCustomData = updatedCustomData.map((item) => {
        if (item?.fieldsalesTaxApplicable === true) {
          totalSalesTax += ((item.fieldQuantity * item.fieldPricePerUnit) + item.fieldMargin) * (value / 100);
          return { ...item, fieldsalesTaxPercent: value };
        }
        return item;
      });
    }

    console.log("total sales tax : ", totalSalesTax);

    setNewBidData((prev) => {
      let nextData = {
        ...prev,
        salesTaxPercent: value,
        salesTax: totalSalesTax,
        bidCustomData: updatedCustomData
      };
      
      if(prev.l2Charger && prev.l2Charger.salesTaxApplicable) nextData.l2Charger = { ...prev.l2Charger, salesTaxPercent: value };
      if(prev.l3Charger && prev.l3Charger.salesTaxApplicable) nextData.l3Charger = { ...prev.l3Charger, salesTaxPercent: value };
      if(prev.electricalWork && prev.electricalWork.salesTaxApplicable) nextData.electricalWork = { ...prev.electricalWork, salesTaxPercent: value };
      if(prev.wifiAntenna && prev.wifiAntenna.salesTaxApplicable) nextData.wifiAntenna = { ...prev.wifiAntenna, salesTaxPercent: value };
      if(prev.wifiConnectivity && prev.wifiConnectivity.salesTaxApplicable) nextData.wifiConnectivity = { ...prev.wifiConnectivity, salesTaxPercent: value };
      if(prev.warranty && prev.warranty.salesTaxApplicable) nextData.warranty = { ...prev.warranty, salesTaxPercent: value };
      if(prev.shipping && prev.shipping.salesTaxApplicable) nextData.shipping = { ...prev.shipping, salesTaxPercent: value };
      if(prev.signage && prev.signage.salesTaxApplicable) nextData.signage = { ...prev.signage, salesTaxPercent: value };
      if(prev.pedestals && prev.pedestals.salesTaxApplicable) nextData.pedestals = { ...prev.pedestals, salesTaxPercent: value };
      if(prev.simCard4G && prev.simCard4G.salesTaxApplicable) nextData.simCard4G = { ...prev.simCard4G, salesTaxPercent: value };
      if(prev.siteWiFi && prev.siteWiFi.salesTaxApplicable) nextData.siteWiFi = { ...prev.siteWiFi, salesTaxPercent: value };
      if(prev.chargerInstallOnly && prev.chargerInstallOnly.salesTaxApplicable) nextData.chargerInstallOnly = { ...prev.chargerInstallOnly, salesTaxPercent: value };

      return nextData;
    });

    return totalSalesTax;
  };

  useEffect(()=>{
    if(selectedDeal && bidData === null){
      if(selectedDeal.software_only && (selectedDefaultItems.softwareOnly === false && (bidData ? (bidData?.softwareOnly === true) : true)) ){
        setSelectedDefaultItems((prev)=>{
          return {
            ...prev,
            softwareOnly: true
          }
        })
        setNewBidData((prev)=>{
          return {
            ...prev,
            softwareOnly: true
          }
        })
      }
      if(selectedDeal.l2_chargers && selectedDeal.l2_chargers > 0 && selectedDefaultItems.l2Charger === false && selectedDefaultItems.softwareOnly === false){
        setSelectedDefaultItems((prev)=>{
          return {
            ...prev,
            l2Charger: true
          }
        })
        setNewBidData((prev)=>{
          return {
            ...prev,
            l2Charger: {
              title: defaultItems.l2Charger.title,
              description: defaultItems.l2Charger.description,
              pricePerUnit: defaultItems.l2Charger.unit_price,
              quantity: selectedDeal.l2_chargers,
              margin: defaultItems.l2Charger.margin,
              salesTaxApplicable: defaultItems.l2Charger.salesTaxApplicable,
              salesTaxPercent: defaultItems.l2Charger.salesTaxPercent
            }
          }
        })
      }
      if(selectedDeal.l3_chargers && selectedDeal.l3_chargers > 0 && selectedDefaultItems.l3Charger === false && selectedDefaultItems.softwareOnly === false){
        setSelectedDefaultItems((prev)=>{
          return {
            ...prev,
            l3Charger: true
          }
        })
        setNewBidData((prev)=>{
          return {
            ...prev,
            l3Charger: {
              title: defaultItems.l3Charger.title,
              description: defaultItems.l3Charger.description,
              pricePerUnit: defaultItems.l3Charger.unit_price,
              quantity: selectedDeal.l3_chargers,
              margin: defaultItems.l3Charger.margin,
              salesTaxApplicable: defaultItems.l3Charger.salesTaxApplicable,
              salesTaxPercent: defaultItems.l3Charger.salesTaxPercent

            }
          }
        })
      }
      if(selectedDeal.lte_hardware && selectedDeal.lte_hardware > 0 && selectedDefaultItems.wifiAntenna === false){
         setSelectedDefaultItems((prev)=>{
          return {
            ...prev,
            wifiAntenna: true
          }
        })
        setNewBidData((prev)=>{
          return {
            ...prev,
            wifiAntenna: {
              title: defaultItems.wifiAntenna.title,
              description: defaultItems.wifiAntenna.description,
              pricePerUnit: defaultItems.wifiAntenna.unit_price,
              quantity: selectedDeal.lte_hardware,
              margin: defaultItems.wifiAntenna.margin,
              salesTaxApplicable: defaultItems.wifiAntenna.salesTaxApplicable,
              salesTaxPercent: defaultItems.wifiAntenna.salesTaxPercent,

            }
          }
        })
      }
      if(selectedDeal.pedestals && selectedDeal.pedestals > 0 && selectedDefaultItems.pedestals === false){
        setSelectedDefaultItems((prev)=>{
          return {
            ...prev,
            pedestals: true
          }
        })
        setNewBidData((prev)=>{
          return {
            ...prev,
            pedestals: {
              title: defaultItems.pedestals.title,
              description: defaultItems.pedestals.description,
              pricePerUnit: defaultItems.pedestals.unit_price,
              quantity: selectedDeal.pedestals,
              margin: defaultItems.pedestals.margin,
              salesTaxApplicable: defaultItems.pedestals.salesTaxApplicable,
              salesTaxPercent: defaultItems.pedestals.salesTaxPercent,
            }
          }
        })
      }
      if(selectedDeal.site_wifi_available && selectedDeal.site_wifi_available > 0 && selectedDefaultItems.siteWiFi === false){
        setSelectedDefaultItems((prev)=>{
          return {
            ...prev,
            siteWiFi: true
          }
        })
        setNewBidData((prev)=>{
          return {
            ...prev,
            siteWiFi: {
              title: defaultItems.siteWiFi.title,
              description: defaultItems.siteWiFi.description,
              pricePerUnit: defaultItems.siteWiFi.unit_price,
              quantity: selectedDeal.siteWiFi,
              margin: defaultItems.siteWiFi.margin,
              salesTaxApplicable: defaultItems.siteWiFi.salesTaxApplicable,
              salesTaxPercent: defaultItems.siteWiFi.salesTaxPercent,
            }
          }
        })
      }
      if(selectedDeal.signage && selectedDeal.signage > 0 && selectedDefaultItems.signage === false){
        setSelectedDefaultItems((prev)=>{
          return {
            ...prev,
            signage: true
          }
        })
        setNewBidData((prev)=>{
          return {
            ...prev,
            signage: {
              title: defaultItems.signage.title,
              description: defaultItems.signage.description,
              pricePerUnit: defaultItems.signage.unit_price,
              quantity: selectedDeal.signage,
              margin: defaultItems.signage.margin,
              salesTaxApplicable: defaultItems.signage.salesTaxApplicable,
              salesTaxPercent: defaultItems.signage.salesTaxPercent,

            }
          }
        })
      }
      

    }
  }, [selectedDeal])

  useEffect(() => {
    CalculateTotalCost();
    if( newBidData.salesTaxPercent !== undefined && newBidData.salesTaxPercent !== null && newBidData.salesTaxPercent !== 0){
      handleSalesTaxPercentChange(newBidData.salesTaxPercent, newBidData);
    }
  }, [newBidData]);

  const handleCheckedFieldAddToBid = (field, checked) => {
    setSelectedDefaultItems((prev) => ({
      ...prev,
      [`${field}`]: checked,
      softwareOnly: (field === "l2Charger" || field === "l3Charger") ? false : prev.softwareOnly
    }));
    if (checked) {
      const item = defaultItems[field];
      setNewBidData((prev) => ({
        ...prev,
        [`${field}`]: {
          title: item.title,
          description: item.description,
          pricePerUnit: item.unit_price,
          quantity: item.quantity,
          margin: item.margin,
          salesTaxApplicable: item.salesTaxApplicable,
          salesTaxPercent: item.salesTaxPercent,

        },
      }));
    } else {
      setNewBidData((prev) => {
        const updated = { ...prev };
        delete updated[field]; // 🔑 remove the field
        console.log("updated fields: ", updated);
        return updated;
      });
    }
  };

  const handleCustomFieldChange = (index, field, value) => {
    setNewBidData((prev) => {
      const updatedCustomData = [...prev.bidCustomData];
      updatedCustomData[index] = {
        ...updatedCustomData[index],
        [field]: value,
      };
      return { ...prev, bidCustomData: updatedCustomData };
    });
  };

  const onFinish = async (values) => {
    console.log("Received values of form: ", values);
    console.log("New Bid Data: ", newBidData);
    try {
      let response = editBid
        ? await BreathAPIs.updateBid(newBidData, bidData?._id)
        : await BreathAPIs.createBid(newBidData, selectedDeal._id);
      console.log("response of bid crate", response);
      if (response.status === 200) {
        toast.success(response.data.message);
        setShowBidCreateModel(!showBidCreateModel);
        if (getDealBids !== null) {
          getDealBids(selectedDeal?._id);
        }
      }
    } catch (error) {
      console.log("error in bid create api callj", error);
      toast.error(error.message);
    }
    // setNewBidData(values);
  };

  return (
    <>
      <Title level={4}>{editBid ? "Edit Bid" : "Create a new bid"}</Title>

      <p>Selected Deal: {selectedDeal?.dealname || "Not Available"}</p>

      <Form
        form={form}
        name="create_bid_form"
        onFinish={onFinish}
        layout="vertical"
      >
        <Form.Item
          name="softwareOnly"
          label="Software Only"
          // valuePropName="checked"
        >
          <Switch
            checked={newBidData.softwareOnly}
            onChange={(checked) =>{
              // setNewBidData({ ...newBidData, softwareOnly: checked });
              if(checked){
                setSelectedDefaultItems({...selectedDefaultItems,
                  l2Charger: false,
                  l3Charger: false,
                  softwareOnly: true
                });
                setNewBidData( (prev) => {
                  const {l2Charger, l3Charger, ...rest} = prev;
                  return {...rest, softwareOnly: true};
                });
              }else{
                setSelectedDefaultItems({...selectedDefaultItems,
                  softwareOnly: false
                });
                setNewBidData({ ...newBidData, softwareOnly: false });
              }
              
            }
            }
          />
        </Form.Item>
        <div className={styles["l2-charger-form"]}>
          <Title level={5}>Contact</Title>
          <Form.Item label="Name">
            <Input
              value={newBidData?.name ? newBidData?.name : ""}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  name: e.target.value,
                }));
              }}
            ></Input>
          </Form.Item>
          <Form.Item label="Email">
            <Input
              value={newBidData?.email ? newBidData?.email : ""}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  email: e.target.value,
                }));
              }}
            ></Input>
          </Form.Item>

          <Form.Item label="Phone">
            <Input
              value={newBidData?.phone ? newBidData?.phone : ""}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  phone: e.target.value,
                }));
              }}
            ></Input>
          </Form.Item>
        </div>
        <div className={styles["l2-charger-form"]}>
          <Title level={5}>Deal POC</Title>
          <Form.Item label="Name">
            <Input
              value={newBidData?.dealPOC.name ? newBidData?.dealPOC.name : ""}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  dealPOC: { ...prev.dealPOC, name: e.target.value },
                }));
              }}
            ></Input>
          </Form.Item>
          <Form.Item label="Email">
            <Input
              value={newBidData?.dealPOC.email ? newBidData?.dealPOC.email : ""}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  dealPOC: { ...prev.dealPOC, email: e.target.value },
                }));
              }}
            ></Input>
          </Form.Item>

          <Form.Item label="Phone">
            <Input
              value={newBidData?.dealPOC.phone ? newBidData?.dealPOC.phone : ""}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  dealPOC: { ...prev.dealPOC, phone: e.target.value },
                }));
              }}
            ></Input>
          </Form.Item>
        </div>

        {/* L2 chargers  */}
        <div className={styles["l2-charger-form"]}>
          <Title level={5}>L2 Chargers</Title>

          <Form.Item>
            <Checkbox
              checked={selectedDefaultItems.l2Charger}
              onChange={(e) => {
                handleCheckedFieldAddToBid("l2Charger", e.target.checked);
              }}
              disabled={newBidData.softwareOnly}
            >
              Add to Bid
            </Checkbox>
          </Form.Item>
          <div className={selectedDefaultItems.l2Charger ? styles.contentDivOpen : styles.contentDiv}>
            <div className={styles.contentInner}>
              <Form.Item label="Title">
                <Input
                  value={
                    newBidData?.l2Charger?.title ? newBidData?.l2Charger?.title : ""
                  }
                  disabled={!selectedDefaultItems.l2Charger}
                  onChange={(e) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      l2Charger: {
                        ...prev.l2Charger,
                        title: e.target.value,
                      },
                    }));
                  }}
                ></Input>
              </Form.Item>

              <Form.Item label="Description">
                <Input.TextArea
                  value={
                    newBidData?.l2Charger?.description
                      ? newBidData?.l2Charger?.description
                      : ""
                  }
                  disabled={!selectedDefaultItems.l2Charger}
                  onChange={(e) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      l2Charger: {
                        ...prev.l2Charger,
                        description: e.target.value,
                      },
                    }));
                  }}
                />
              </Form.Item>

              <Form.Item label="Quantity">
                <InputNumber
                  controls={false}
                  min={0}
                  value={
                    newBidData?.l2Charger?.quantity
                      ? newBidData?.l2Charger?.quantity
                      : 0
                  }
                  disabled={!selectedDefaultItems.l2Charger}
                  onChange={(value) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      l2Charger: {
                        ...prev.l2Charger,
                        quantity: value,
                      },
                      salesTax: (() => {
                        if (!prev.l2Charger?.salesTaxApplicable) return prev.salesTax || 0;
                        const oldTax = ((prev.l2Charger?.margin || 0) + (prev.l2Charger?.quantity || 0) * (prev.l2Charger?.pricePerUnit || 0)) * (prev.l2Charger?.salesTaxPercent || 0) / 100;
                        const newTax = ((prev.l2Charger?.margin || 0) + value * (prev.l2Charger?.pricePerUnit || 0)) * (prev.l2Charger?.salesTaxPercent || 0) / 100;
                        return (prev.salesTax || 0) - oldTax + newTax;
                      })(),
                    }));
                  }}
                />
              </Form.Item>

              <Form.Item label="Cost Per Unit">
                <InputNumber
                  controls={false}
                  min={0}
                  precision={2}
                  formatter={(value) =>
                    `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                  disabled={!selectedDefaultItems.l2Charger}
                  value={
                    newBidData?.l2Charger?.pricePerUnit
                      ? newBidData?.l2Charger?.pricePerUnit
                      : 0
                  }
                  onChange={(value) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      l2Charger: {
                        ...prev.l2Charger,
                        pricePerUnit: value,
                      },
                      salesTax: (() => {
                        if (!prev.l2Charger?.salesTaxApplicable) return prev.salesTax || 0;
                        const oldTax = ((prev.l2Charger?.margin || 0) + (prev.l2Charger?.quantity || 0) * (prev.l2Charger?.pricePerUnit || 0)) * (prev.l2Charger?.salesTaxPercent || 0) / 100;
                        const newTax = ((prev.l2Charger?.margin || 0) + (prev.l2Charger?.quantity || 0) * value) * (prev.l2Charger?.salesTaxPercent || 0) / 100;
                        return (prev.salesTax || 0) - oldTax + newTax;
                      })(),
                    }));
                  }}
                />
              </Form.Item>
              <Form.Item label="Total Margin ($)">
                <InputNumber
                  controls={false}
                  min={0}
                  disabled={!selectedDefaultItems.l2Charger}
                  value={
                    newBidData?.l2Charger?.margin
                      ? newBidData?.l2Charger?.margin
                      : 0
                  }
                  onChange={(value) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      l2Charger: {
                        ...prev.l2Charger,
                        margin: value,
                        // pricePerUnit: ((prev.l2Charger.quantity * prev.l2Charger.pricePerUnit) + value)/prev?.l2Charger?.quantity
                      },
                      salesTax: (() => {
                        if (!prev.l2Charger?.salesTaxApplicable) return prev.salesTax || 0;
                        const oldTax = ((prev.l2Charger?.margin || 0) + (prev.l2Charger?.quantity || 0) * (prev.l2Charger?.pricePerUnit || 0)) * (prev.l2Charger?.salesTaxPercent || 0) / 100;
                        const newTax = (value + (prev.l2Charger?.quantity || 0) * (prev.l2Charger?.pricePerUnit || 0)) * (prev.l2Charger?.salesTaxPercent || 0) / 100;
                        return (prev.salesTax || 0) - oldTax + newTax;
                      })(),
                    }));
                  }}
                />
                <span
                  style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}
                >
                  Margin % applied on Total Price:
                  <b
                    style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}
                  >
                    {newBidData?.l2Charger?.quantity &&
                      newBidData?.l2Charger?.margin
                      ? (
                        (newBidData?.l2Charger?.margin /
                          (newBidData.l2Charger.quantity *
                            newBidData.l2Charger.pricePerUnit +
                            newBidData?.l2Charger?.margin)) *
                        100
                      ).toFixed(2)
                      : "0.0"}{" "}
                    %
                  </b>
                </span>
                
              </Form.Item>
              <div>
                  <Form.Item label= "Is sales tax applicable?" valuePropName="checked">
                    <Switch onChange={
                      (checked) => {
                        let newBidDataValue = {...newBidData}
                        newBidDataValue.l2Charger.salesTaxApplicable = checked
                        newBidDataValue.l2Charger.salesTaxPercent = checked ? newBidData.salesTaxPercent : 0
                        setNewBidData((prev) => ({
                          ...prev,
                          l2Charger: {
                            ...prev.l2Charger,
                            salesTaxApplicable: checked,
                            salesTaxPercent: checked ? newBidData.salesTaxPercent : 0,
                          },
                          salesTax: checked ? handleSalesTaxPercentChange(newBidData.salesTaxPercent, newBidDataValue) : prev.salesTax - (((prev.l2Charger.quantity * prev.l2Charger.pricePerUnit) + prev.l2Charger.margin) * newBidData.salesTaxPercent / 100 || 0)
                        }));
                      }
                    } 
                    checked={newBidData?.l2Charger?.salesTaxApplicable}
                    />
                    {console.log("sales tax applicable: ", newBidData?.l2Charger?.salesTaxApplicable)}
                  </Form.Item>
                  {false && <Form.Item label="Sales Tax Percent">
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <InputNumber
                        controls={false}
                        min={0}
                        max={100}
                        disabled={!selectedDefaultItems.l2Charger || !newBidData?.l2Charger?.salesTaxApplicable}
                        value={
                          newBidData?.l2Charger?.salesTaxPercent
                            ? newBidData?.l2Charger?.salesTaxPercent
                            : 0
                        }
                        onChange={(value) => {
                          setNewBidData((prev) => ({
                            ...prev,
                            l2Charger: {
                              ...prev.l2Charger,
                              salesTaxPercent: value
                            },
                            salesTax: (()=>{
                              if(!prev.l2Charger?.salesTaxApplicable) return prev.salesTax || 0;
                              const oldTax = ((prev.l2Charger?.margin || 0) + (prev.l2Charger.quantity * prev.l2Charger.pricePerUnit)) * (prev.l2Charger.salesTaxPercent || 0) / 100;
                              const newTax = ((prev.l2Charger?.margin || 0) + (prev.l2Charger.quantity * prev.l2Charger.pricePerUnit)) * (value || 0) / 100;
                              return (prev.salesTax || 0) - oldTax + newTax;
                            })(),
                            
                            // prev.salesTax ? prev.salesTax + ((newBidData?.l2Charger?.quantity *
                            //   (newBidData?.l2Charger?.pricePerUnit + newBidData?.l2Charger?.margin) *
                            //   value) / 100 || 0) : (newBidData?.l2Charger?.quantity *
                            //   (newBidData?.l2Charger?.pricePerUnit + newBidData?.l2Charger?.margin) *
                            //   value) / 100 || 0,
            
                          }
                          
                        ));
                        }}
                      />
                      <span style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}>
                        {newBidData?.l2Charger?.salesTaxApplicable
                          ? <>
                              Total Sales Tax Amount:
                              <b style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}>
                                ${(newBidData?.l2Charger?.salesTaxPercent *
                                  ((newBidData?.l2Charger?.quantity *
                                    newBidData?.l2Charger?.pricePerUnit) + newBidData?.l2Charger?.margin)
                                  / 100 || 0).toFixed(2)}
                              </b>
                            </>
                          : "Sales Tax: Not applicable"}
                      </span>
                    </div>
                  </Form.Item>}

                </div>

              <div className={styles.priceContainer}>
                Price per item:{" "}
                <b>
                  {newBidData?.l2Charger?.quantity &&
                    newBidData?.l2Charger?.pricePerUnit
                    ? `$${(
                      (newBidData.l2Charger.quantity *
                        newBidData.l2Charger.pricePerUnit +
                        newBidData?.l2Charger?.margin) * (
                          1 + (newBidData?.l2Charger?.salesTaxPercent || 0) / 100
                        ) /
                      newBidData?.l2Charger?.quantity
                    ).toFixed(2)}`
                    : "$0.00"}
                </b>
              </div>
              <div className={styles.priceContainer}>
                Price per item (excl. tax):{" "}
                <b>
                  {newBidData?.l2Charger?.quantity &&
                    newBidData?.l2Charger?.pricePerUnit
                    ? `$${(
                      (newBidData.l2Charger.quantity *
                        newBidData.l2Charger.pricePerUnit +
                        (newBidData?.l2Charger?.margin || 0)) /
                      newBidData?.l2Charger?.quantity
                    ).toFixed(2)}`
                    : "$0.00"}
                </b>
              </div>
              <div className={styles.priceContainer}>
                Total Price:{" "}
                <b>
                  {newBidData?.l2Charger?.quantity &&
                    newBidData?.l2Charger?.pricePerUnit
                    ? `$${(
                      (newBidData.l2Charger.quantity *
                      newBidData.l2Charger.pricePerUnit +
                      newBidData?.l2Charger?.margin) * (
                        1 + (newBidData?.l2Charger?.salesTaxPercent || 0) / 100
                      )
                    ).toFixed(2)}`
                    : "$0.00"}
                </b>
              </div>
              <div className={styles.priceContainer}>
                Total Price (excl. tax):{" "}
                <b>
                  {newBidData?.l2Charger?.quantity &&
                    newBidData?.l2Charger?.pricePerUnit
                    ? `$${(
                      newBidData.l2Charger.quantity *
                      newBidData.l2Charger.pricePerUnit +
                      (newBidData?.l2Charger?.margin || 0)
                    ).toFixed(2)}`
                    : "$0.00"}
                </b>
              </div>
            </div>
          </div>
        </div>

        {/* L3 chargers  */}
        <div className={styles["l2-charger-form"]}>
          <Title level={5}>L3 Chargers</Title>

          <Form.Item>
            <Checkbox
              checked={selectedDefaultItems.l3Charger}
              onChange={(e) => {
                handleCheckedFieldAddToBid("l3Charger", e.target.checked);
              }}
              disabled={newBidData.softwareOnly}
            >
              Add to Bid
            </Checkbox>
          </Form.Item>

          <div className={selectedDefaultItems.l3Charger ? styles.contentDivOpen : styles.contentDiv}>
            <div className={styles.contentInner}>

          <Form.Item label="Title">
            <Input
              value={
                newBidData?.l3Charger?.title ? newBidData?.l3Charger?.title : ""
              }
              disabled={!selectedDefaultItems.l3Charger}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  l3Charger: {
                    ...prev.l3Charger,
                    title: e.target.value,
                  },
                }));
              }}
            ></Input>
          </Form.Item>

          <Form.Item label="Description">
            <Input.TextArea
              value={
                newBidData?.l3Charger?.description
                  ? newBidData?.l3Charger?.description
                  : ""
              }
              disabled={!selectedDefaultItems.l3Charger}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  l3Charger: {
                    ...prev.l3Charger,
                    description: e.target.value,
                  },
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Quantity">
            <InputNumber
              controls={false}
              min={0}
              value={
                newBidData?.l3Charger?.quantity
                  ? newBidData?.l3Charger?.quantity
                  : 0
              }
              disabled={!selectedDefaultItems.l3Charger}
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  l3Charger: {
                    ...prev.l3Charger,
                    quantity: value,
                  },
                  salesTax: (() => {
                    if (!prev.l3Charger?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.l3Charger?.margin || 0) + (prev.l3Charger?.quantity || 0) * (prev.l3Charger?.pricePerUnit || 0)) * (prev.l3Charger?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.l3Charger?.margin || 0) + value * (prev.l3Charger?.pricePerUnit || 0)) * (prev.l3Charger?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Cost Per Unit">
            <InputNumber
              controls={false}
              min={0}
              precision={2}
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              disabled={!selectedDefaultItems.l3Charger}
              value={
                newBidData?.l3Charger?.pricePerUnit
                  ? newBidData?.l3Charger?.pricePerUnit
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  l3Charger: {
                    ...prev.l3Charger,
                    pricePerUnit: value,
                  },
                  salesTax: (() => {
                    if (!prev.l3Charger?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.l3Charger?.margin || 0) + (prev.l3Charger?.quantity || 0) * (prev.l3Charger?.pricePerUnit || 0)) * (prev.l3Charger?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.l3Charger?.margin || 0) + (prev.l3Charger?.quantity || 0) * value) * (prev.l3Charger?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Total Margin ($)">
            <InputNumber
              controls={false}
              min={0}
              disabled={!selectedDefaultItems.l3Charger}
              value={
                newBidData?.l3Charger?.margin
                  ? newBidData?.l3Charger?.margin
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  l3Charger: {
                    ...prev.l3Charger,
                    margin: value,
                  },
                  salesTax: (() => {
                    if (!prev.l3Charger?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.l3Charger?.margin || 0) + (prev.l3Charger?.quantity || 0) * (prev.l3Charger?.pricePerUnit || 0)) * (prev.l3Charger?.salesTaxPercent || 0) / 100;
                    const newTax = (value + (prev.l3Charger?.quantity || 0) * (prev.l3Charger?.pricePerUnit || 0)) * (prev.l3Charger?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
            <span
              style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}
            >
              Margin % applied on Total Price:
              <b
                style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}
              >
                {newBidData?.l3Charger?.quantity &&
                  newBidData?.l3Charger?.margin
                  ? (
                    (newBidData?.l3Charger?.margin /
                      (newBidData.l3Charger.quantity *
                        newBidData.l3Charger.pricePerUnit +
                        newBidData?.l3Charger?.margin)) *
                    100
                  ).toFixed(2)
                  : "0.0"}{" "}
                %
              </b>
            </span>
          </Form.Item>
          <div>
            <Form.Item label="Is sales tax applicable?" valuePropName="checked">
              <Switch onChange={(checked) => {
                let newBidDataValue = {...newBidData}
                newBidDataValue.l3Charger.salesTaxApplicable = checked
                newBidDataValue.l3Charger.salesTaxPercent = checked ? newBidData.salesTaxPercent : 0
                setNewBidData((prev) => ({
                  ...prev,
                  l3Charger: {
                    ...prev.l3Charger,
                    salesTaxApplicable: checked,
                    salesTaxPercent: checked ? newBidData.salesTaxPercent : 0,
                  },
                  salesTax: checked ? handleSalesTaxPercentChange(newBidData.salesTaxPercent, newBidDataValue) : (prev.salesTax || 0) - (((prev.l3Charger?.margin || 0) + (prev.l3Charger?.quantity || 0) * (prev.l3Charger?.pricePerUnit || 0)) * (newBidData.salesTaxPercent || 0) / 100),
                }));
              }}
              checked={newBidData?.l3Charger?.salesTaxApplicable}
              />
            </Form.Item>
            {false && <Form.Item label="Sales Tax Percent">
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <InputNumber
                  controls={false}
                  min={0}
                  max={100}
                  disabled={!selectedDefaultItems.l3Charger || !newBidData?.l3Charger?.salesTaxApplicable}
                  value={newBidData?.l3Charger?.salesTaxPercent ? newBidData?.l3Charger?.salesTaxPercent : 0}
                  onChange={(value) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      l3Charger: {
                        ...prev.l3Charger,
                        salesTaxPercent: value
                      },
                      salesTax: (() => {
                        if (!prev.l3Charger?.salesTaxApplicable) return prev.salesTax || 0;
                        const oldTax = ((prev.l3Charger?.margin || 0) + (prev.l3Charger?.quantity || 0) * (prev.l3Charger?.pricePerUnit || 0)) * (prev.l3Charger?.salesTaxPercent || 0) / 100;
                        const newTax = ((prev.l3Charger?.margin || 0) + (prev.l3Charger?.quantity || 0) * (prev.l3Charger?.pricePerUnit || 0)) * (value || 0) / 100;
                        return (prev.salesTax || 0) - oldTax + newTax;
                      })(),
                    }));
                  }}
                />
                <span style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}>
                  {newBidData?.l3Charger?.salesTaxApplicable
                    ? <>
                        Total Sales Tax Amount:
                        <b style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}>
                          ${(newBidData?.l3Charger?.salesTaxPercent *
                            ((newBidData?.l3Charger?.quantity *
                              newBidData?.l3Charger?.pricePerUnit) + newBidData?.l3Charger?.margin)
                            / 100 || 0).toFixed(2)}
                        </b>
                      </>
                    : "Sales Tax: Not applicable"}
                </span>
              </div>
            </Form.Item>}
          </div>
          <div className={styles.priceContainer}>
            Price per item:{" "}
            <b>
              {newBidData?.l3Charger?.quantity &&
                newBidData?.l3Charger?.pricePerUnit
                ? `$${(
                  (newBidData.l3Charger.quantity *
                    newBidData.l3Charger.pricePerUnit +
                    newBidData?.l3Charger?.margin) *
                  (1 + (newBidData?.l3Charger?.salesTaxPercent || 0) / 100) /
                  newBidData?.l3Charger?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Price per item (excl. tax):{" "}
            <b>
              {newBidData?.l3Charger?.quantity &&
                newBidData?.l3Charger?.pricePerUnit
                ? `$${(
                  (newBidData.l3Charger.quantity *
                    newBidData.l3Charger.pricePerUnit +
                    (newBidData?.l3Charger?.margin || 0)) /
                  newBidData?.l3Charger?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price:{" "}
            <b>
              {newBidData?.l3Charger?.quantity &&
                newBidData?.l3Charger?.pricePerUnit
                ? `$${(
                  (newBidData.l3Charger.quantity *
                  newBidData.l3Charger.pricePerUnit +
                  newBidData?.l3Charger?.margin) *
                  (1 + (newBidData?.l3Charger?.salesTaxPercent || 0) / 100)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price (excl. tax):{" "}
            <b>
              {newBidData?.l3Charger?.quantity &&
                newBidData?.l3Charger?.pricePerUnit
                ? `$${(
                  newBidData.l3Charger.quantity *
                  newBidData.l3Charger.pricePerUnit +
                  (newBidData?.l3Charger?.margin || 0)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>

          </div>
          </div>
        </div>

        {/* electricalWork  */}
        <div className={styles["l2-charger-form"]}>
          <Title level={5}>Full Install</Title>

          <Form.Item>
            <Checkbox
              checked={selectedDefaultItems.electricalWork}
              onChange={(e) => {
                handleCheckedFieldAddToBid("electricalWork", e.target.checked);
              }}
            >
              Add to Bid
            </Checkbox>
          </Form.Item>

          <div className={selectedDefaultItems.electricalWork ? styles.contentDivOpen : styles.contentDiv}>
            <div className={styles.contentInner}>

          <Form.Item label="Title">
            <Input
              value={
                newBidData?.electricalWork?.title
                  ? newBidData?.electricalWork?.title
                  : ""
              }
              disabled={!selectedDefaultItems.electricalWork}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  electricalWork: {
                    ...prev.electricalWork,
                    title: e.target.value,
                  },
                }));
              }}
            ></Input>
          </Form.Item>

          <Form.Item label="Description">
            <Input.TextArea
              value={
                newBidData?.electricalWork?.description
                  ? newBidData?.electricalWork?.description
                  : ""
              }
              disabled={!selectedDefaultItems.electricalWork}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  electricalWork: {
                    ...prev.electricalWork,
                    description: e.target.value,
                  },
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Quantity">
            <InputNumber
              controls={false}
              min={0}
              value={
                newBidData?.electricalWork?.quantity
                  ? newBidData?.electricalWork?.quantity
                  : 0
              }
              disabled={!selectedDefaultItems.electricalWork}
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  electricalWork: {
                    ...prev.electricalWork,
                    quantity: value,
                  },
                  salesTax: (() => {
                    if (!prev.electricalWork?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.electricalWork?.margin || 0) + (prev.electricalWork?.quantity || 0) * (prev.electricalWork?.pricePerUnit || 0)) * (prev.electricalWork?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.electricalWork?.margin || 0) + value * (prev.electricalWork?.pricePerUnit || 0)) * (prev.electricalWork?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Cost Per Unit">
            <InputNumber
              controls={false}
              min={0}
              precision={2}
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              disabled={!selectedDefaultItems.electricalWork}
              value={
                newBidData?.electricalWork?.pricePerUnit
                  ? newBidData?.electricalWork?.pricePerUnit
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  electricalWork: {
                    ...prev.electricalWork,
                    pricePerUnit: value,
                  },
                  salesTax: (() => {
                    if (!prev.electricalWork?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.electricalWork?.margin || 0) + (prev.electricalWork?.quantity || 0) * (prev.electricalWork?.pricePerUnit || 0)) * (prev.electricalWork?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.electricalWork?.margin || 0) + (prev.electricalWork?.quantity || 0) * value) * (prev.electricalWork?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Total Margin ($)">
            <InputNumber
              controls={false}
              min={0}
              disabled={!selectedDefaultItems.electricalWork}
              value={
                newBidData?.electricalWork?.margin
                  ? newBidData?.electricalWork?.margin
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  electricalWork: {
                    ...prev.electricalWork,
                    margin: value,
                  },
                  salesTax: (() => {
                    if (!prev.electricalWork?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.electricalWork?.margin || 0) + (prev.electricalWork?.quantity || 0) * (prev.electricalWork?.pricePerUnit || 0)) * (prev.electricalWork?.salesTaxPercent || 0) / 100;
                    const newTax = (value + (prev.electricalWork?.quantity || 0) * (prev.electricalWork?.pricePerUnit || 0)) * (prev.electricalWork?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
            <span
              style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}
            >
              Margin % applied on Total Price:
              <b
                style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}
              >
                {newBidData?.electricalWork?.quantity &&
                  newBidData?.electricalWork?.margin
                  ? (
                    (newBidData?.electricalWork?.margin /
                      (newBidData.electricalWork.quantity *
                        newBidData.electricalWork.pricePerUnit +
                        newBidData?.electricalWork?.margin)) *
                    100
                  ).toFixed(2)
                  : "0.0"}{" "}
                %
              </b>
            </span>
          </Form.Item>
          <div>
            <Form.Item label="Is sales tax applicable?" valuePropName="checked">
              <Switch onChange={(checked) => {
                let newBidDataValue = {...newBidData}
                newBidDataValue.electricalWork.salesTaxApplicable = checked
                newBidDataValue.electricalWork.salesTaxPercent = checked ? newBidData.salesTaxPercent : 0
                setNewBidData((prev) => ({
                  ...prev,
                  electricalWork: { 
                    ...prev.electricalWork,
                    salesTaxApplicable: checked,
                    salesTaxPercent: checked ? newBidData.salesTaxPercent : 0,
                  },
                  salesTax: checked ? handleSalesTaxPercentChange(newBidData.salesTaxPercent, newBidDataValue) : (prev.salesTax || 0) - (((prev.electricalWork?.margin || 0) + (prev.electricalWork?.quantity || 0) * (prev.electricalWork?.pricePerUnit || 0)) * (newBidData.salesTaxPercent || 0) / 100),
                }));
              }}
              checked={newBidData?.electricalWork?.salesTaxApplicable}
              />
            </Form.Item>
            {false && <Form.Item label="Sales Tax Percent">
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <InputNumber
                  controls={false}
                  min={0}
                  max={100}
                  disabled={!selectedDefaultItems.electricalWork || !newBidData?.electricalWork?.salesTaxApplicable}
                  value={newBidData?.electricalWork?.salesTaxPercent ? newBidData?.electricalWork?.salesTaxPercent : 0}
                  onChange={(value) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      electricalWork: {
                        ...prev.electricalWork,
                        salesTaxPercent: value
                      },
                      salesTax: (() => {
                        if (!prev.electricalWork?.salesTaxApplicable) return prev.salesTax || 0;
                        const oldTax = ((prev.electricalWork?.margin || 0) + (prev.electricalWork?.quantity || 0) * (prev.electricalWork?.pricePerUnit || 0)) * (prev.electricalWork?.salesTaxPercent || 0) / 100;
                        const newTax = ((prev.electricalWork?.margin || 0) + (prev.electricalWork?.quantity || 0) * (prev.electricalWork?.pricePerUnit || 0)) * (value || 0) / 100;
                        return (prev.salesTax || 0) - oldTax + newTax;
                      })(),
                    }));
                  }}
                />
                <span style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}>
                  {newBidData?.electricalWork?.salesTaxApplicable
                    ? <>
                        Total Sales Tax Amount:
                        <b style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}>
                          ${(newBidData?.electricalWork?.salesTaxPercent *
                            ((newBidData?.electricalWork?.quantity *
                              newBidData?.electricalWork?.pricePerUnit) + newBidData?.electricalWork?.margin)
                            / 100 || 0).toFixed(2)}
                        </b>
                      </>
                    : "Sales Tax: Not applicable"}
                </span>
              </div>
            </Form.Item>}
          </div>
          <div className={styles.priceContainer}>
            Price per item:{" "}
            <b>
              {newBidData?.electricalWork?.quantity &&
                newBidData?.electricalWork?.pricePerUnit
                ? `$${(
                  (newBidData.electricalWork.quantity *
                    newBidData.electricalWork.pricePerUnit +
                    newBidData?.electricalWork?.margin) *
                  (1 + (newBidData?.electricalWork?.salesTaxPercent || 0) / 100) /
                  newBidData?.electricalWork?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Price per item (excl. tax):{" "}
            <b>
              {newBidData?.electricalWork?.quantity &&
                newBidData?.electricalWork?.pricePerUnit
                ? `$${(
                  (newBidData.electricalWork.quantity *
                    newBidData.electricalWork.pricePerUnit +
                    (newBidData?.electricalWork?.margin || 0)) /
                  newBidData?.electricalWork?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price:{" "}
            <b>
              {newBidData?.electricalWork?.quantity &&
                newBidData?.electricalWork?.pricePerUnit
                ? `$${(
                  (newBidData.electricalWork.quantity *
                  newBidData.electricalWork.pricePerUnit +
                  newBidData?.electricalWork?.margin) *
                  (1 + (newBidData?.electricalWork?.salesTaxPercent || 0) / 100)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price (excl. tax):{" "}
            <b>
              {newBidData?.electricalWork?.quantity &&
                newBidData?.electricalWork?.pricePerUnit
                ? `$${(
                  newBidData.electricalWork.quantity *
                  newBidData.electricalWork.pricePerUnit +
                  (newBidData?.electricalWork?.margin || 0)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          </div>
          </div>
        </div>

        {/* chargerInstallOnly  */}
        <div className={styles["l2-charger-form"]}>
          <Title level={5}>Charger Install Only</Title>

          <Form.Item>
            <Checkbox
              checked={selectedDefaultItems.chargerInstallOnly}
              onChange={(e) => {
                handleCheckedFieldAddToBid("chargerInstallOnly", e.target.checked);
              }}
            >
              Add to Bid
            </Checkbox>
          </Form.Item>

          <div className={selectedDefaultItems.chargerInstallOnly ? styles.contentDivOpen : styles.contentDiv}>
            <div className={styles.contentInner}>

          <Form.Item label="Title">
            <Input
              value={
                newBidData?.chargerInstallOnly?.title ? newBidData?.chargerInstallOnly?.title : ""
              }
              disabled={!selectedDefaultItems.chargerInstallOnly}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  chargerInstallOnly: {
                    ...prev.chargerInstallOnly,
                    title: e.target.value,
                  },
                }));
              }}
            ></Input>
          </Form.Item>

          <Form.Item label="Description">
            <Input.TextArea
              value={
                newBidData?.chargerInstallOnly?.description
                  ? newBidData?.chargerInstallOnly?.description
                  : ""
              }
              disabled={!selectedDefaultItems.chargerInstallOnly}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  chargerInstallOnly: {
                    ...prev.chargerInstallOnly,
                    description: e.target.value,
                  },
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Quantity">
            <InputNumber
              controls={false}
              min={0}
              value={
                newBidData?.chargerInstallOnly?.quantity
                  ? newBidData?.chargerInstallOnly?.quantity
                  : 0
              }
              disabled={!selectedDefaultItems.chargerInstallOnly}
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  chargerInstallOnly: {
                    ...prev.chargerInstallOnly,
                    quantity: value,
                  },
                  salesTax: (() => {
                    if (!prev.chargerInstallOnly?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.chargerInstallOnly?.margin || 0) + (prev.chargerInstallOnly?.quantity || 0) * (prev.chargerInstallOnly?.pricePerUnit || 0)) * (prev.chargerInstallOnly?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.chargerInstallOnly?.margin || 0) + value * (prev.chargerInstallOnly?.pricePerUnit || 0)) * (prev.chargerInstallOnly?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Cost Per Unit">
            <InputNumber
              controls={false}
              min={0}
              precision={2}
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              disabled={!selectedDefaultItems.chargerInstallOnly}
              value={
                newBidData?.chargerInstallOnly?.pricePerUnit
                  ? newBidData?.chargerInstallOnly?.pricePerUnit
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  chargerInstallOnly: {
                    ...prev.chargerInstallOnly,
                    pricePerUnit: value,
                  },
                  salesTax: (() => {
                    if (!prev.chargerInstallOnly?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.chargerInstallOnly?.margin || 0) + (prev.chargerInstallOnly?.quantity || 0) * (prev.chargerInstallOnly?.pricePerUnit || 0)) * (prev.chargerInstallOnly?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.chargerInstallOnly?.margin || 0) + (prev.chargerInstallOnly?.quantity || 0) * value) * (prev.chargerInstallOnly?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Total Margin ($)">
            <InputNumber
              controls={false}
              min={0}
              disabled={!selectedDefaultItems.chargerInstallOnly}
              value={
                newBidData?.chargerInstallOnly?.margin
                  ? newBidData?.chargerInstallOnly?.margin
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  chargerInstallOnly: {
                    ...prev.chargerInstallOnly,
                    margin: value,
                  },
                  salesTax: (() => {
                    if (!prev.chargerInstallOnly?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.chargerInstallOnly?.margin || 0) + (prev.chargerInstallOnly?.quantity || 0) * (prev.chargerInstallOnly?.pricePerUnit || 0)) * (prev.chargerInstallOnly?.salesTaxPercent || 0) / 100;
                    const newTax = (value + (prev.chargerInstallOnly?.quantity || 0) * (prev.chargerInstallOnly?.pricePerUnit || 0)) * (prev.chargerInstallOnly?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
            <span
              style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}
            >
              Margin % applied on Total Price:
              <b
                style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}
              >
                {newBidData?.chargerInstallOnly?.quantity &&
                  newBidData?.chargerInstallOnly?.margin
                  ? (
                    (newBidData?.chargerInstallOnly?.margin /
                      (newBidData.chargerInstallOnly.quantity *
                        newBidData.chargerInstallOnly.pricePerUnit +
                        newBidData?.chargerInstallOnly?.margin)) *
                    100
                  ).toFixed(2)
                  : "0.0"}{" "}
                %
              </b>
            </span>
          </Form.Item>
          <div>
            <Form.Item label="Is sales tax applicable?" valuePropName="checked">
              <Switch onChange={(checked) => {
                let newBidDataValue = {...newBidData}
                newBidDataValue.chargerInstallOnly.salesTaxApplicable = checked
                newBidDataValue.chargerInstallOnly.salesTaxPercent = checked ? newBidData.salesTaxPercent : 0
                setNewBidData((prev) => ({
                  ...prev,
                  chargerInstallOnly: {
                    ...prev.chargerInstallOnly,
                    salesTaxApplicable: checked,
                    salesTaxPercent: checked ? newBidData.salesTaxPercent : 0,
                  },
                  salesTax: checked ? handleSalesTaxPercentChange(newBidData.salesTaxPercent, newBidDataValue) : (prev.salesTax || 0) - (((prev.chargerInstallOnly?.margin || 0) + (prev.chargerInstallOnly?.quantity || 0) * (prev.chargerInstallOnly?.pricePerUnit || 0)) * (newBidData.salesTaxPercent || 0) / 100),
                }));
              }}
              checked={newBidData?.chargerInstallOnly?.salesTaxApplicable}
            />
            </Form.Item>
            {false && <Form.Item label="Sales Tax Percent">
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <InputNumber
                  controls={false}
                  min={0}
                  max={100}
                  disabled={!selectedDefaultItems.chargerInstallOnly || !newBidData?.chargerInstallOnly?.salesTaxApplicable}
                  value={newBidData?.chargerInstallOnly?.salesTaxPercent ? newBidData?.chargerInstallOnly?.salesTaxPercent : 0}
                  onChange={(value) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      chargerInstallOnly: {
                        ...prev.chargerInstallOnly,
                        salesTaxPercent: value
                      },
                      salesTax: (() => {
                        if (!prev.chargerInstallOnly?.salesTaxApplicable) return prev.salesTax || 0;
                        const oldTax = ((prev.chargerInstallOnly?.margin || 0) + (prev.chargerInstallOnly?.quantity || 0) * (prev.chargerInstallOnly?.pricePerUnit || 0)) * (prev.chargerInstallOnly?.salesTaxPercent || 0) / 100;
                        const newTax = ((prev.chargerInstallOnly?.margin || 0) + (prev.chargerInstallOnly?.quantity || 0) * (prev.chargerInstallOnly?.pricePerUnit || 0)) * (value || 0) / 100;
                        return (prev.salesTax || 0) - oldTax + newTax;
                      })(),
                    }));
                  }}
                />
                <span style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}>
                  {newBidData?.chargerInstallOnly?.salesTaxApplicable
                    ? <>
                        Total Sales Tax Amount:
                        <b style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}>
                          ${(newBidData?.chargerInstallOnly?.salesTaxPercent *
                            ((newBidData?.chargerInstallOnly?.quantity *
                              newBidData?.chargerInstallOnly?.pricePerUnit) + newBidData?.chargerInstallOnly?.margin)
                            / 100 || 0).toFixed(2)}
                        </b>
                      </>
                    : "Sales Tax: Not applicable"}
                </span>
              </div>
            </Form.Item>}
          </div>
          <div className={styles.priceContainer}>
            Price per item:{" "}
            <b>
              {newBidData?.chargerInstallOnly?.quantity &&
                newBidData?.chargerInstallOnly?.pricePerUnit
                ? `$${(
                  (newBidData.chargerInstallOnly.quantity *
                    newBidData.chargerInstallOnly.pricePerUnit +
                    newBidData?.chargerInstallOnly?.margin) *
                  (1 + (newBidData?.chargerInstallOnly?.salesTaxPercent || 0) / 100) /
                  newBidData?.chargerInstallOnly?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Price per item (excl. tax):{" "}
            <b>
              {newBidData?.chargerInstallOnly?.quantity &&
                newBidData?.chargerInstallOnly?.pricePerUnit
                ? `$${(
                  (newBidData.chargerInstallOnly.quantity *
                    newBidData.chargerInstallOnly.pricePerUnit +
                    (newBidData?.chargerInstallOnly?.margin || 0)) /
                  newBidData?.chargerInstallOnly?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price:{" "}
            <b>
              {newBidData?.chargerInstallOnly?.quantity &&
                newBidData?.chargerInstallOnly?.pricePerUnit
                ? `$${(
                  (newBidData.chargerInstallOnly.quantity *
                  newBidData.chargerInstallOnly.pricePerUnit +
                  newBidData?.chargerInstallOnly?.margin) *
                  (1 + (newBidData?.chargerInstallOnly?.salesTaxPercent || 0) / 100)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price (excl. tax):{" "}
            <b>
              {newBidData?.chargerInstallOnly?.quantity &&
                newBidData?.chargerInstallOnly?.pricePerUnit
                ? `$${(
                  newBidData.chargerInstallOnly.quantity *
                  newBidData.chargerInstallOnly.pricePerUnit +
                  (newBidData?.chargerInstallOnly?.margin || 0)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          </div>
          </div>
        </div>

        {/* siteWiFi  */}
        <div className={styles["l2-charger-form"]}>
          <Title level={5}>Site Wi-Fi</Title>

          <Form.Item>
            <Checkbox
              checked={selectedDefaultItems.siteWiFi}
              onChange={(e) => {
                handleCheckedFieldAddToBid("siteWiFi", e.target.checked);
              }}
            >
              Add to Bid
            </Checkbox>
          </Form.Item>

          <div className={selectedDefaultItems.siteWiFi ? styles.contentDivOpen : styles.contentDiv}>
            <div className={styles.contentInner}>

          <Form.Item label="Title">
            <Input
              value={
                newBidData?.siteWiFi?.title ? newBidData?.siteWiFi?.title : ""
              }
              disabled={!selectedDefaultItems.siteWiFi}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  siteWiFi: {
                    ...prev.siteWiFi,
                    title: e.target.value,
                  },
                }));
              }}
            ></Input>
          </Form.Item>

          <Form.Item label="Description">
            <Input.TextArea
              value={
                newBidData?.siteWiFi?.description
                  ? newBidData?.siteWiFi?.description 
                  : ""
              }
              disabled={!selectedDefaultItems.siteWiFi}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  siteWiFi: {
                    ...prev.siteWiFi,
                    description: e.target.value,
                  },
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Quantity">
            <InputNumber
              controls={false}
              min={0}
              value={
                newBidData?.siteWiFi?.quantity
                  ? newBidData?.siteWiFi?.quantity
                  : 0
              }
              disabled={!selectedDefaultItems.siteWiFi}
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  siteWiFi: {
                    ...prev.siteWiFi,
                    quantity: value,
                  },
                  salesTax: (() => {
                    if (!prev.siteWiFi?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.siteWiFi?.margin || 0) + (prev.siteWiFi?.quantity || 0) * (prev.siteWiFi?.pricePerUnit || 0)) * (prev.siteWiFi?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.siteWiFi?.margin || 0) + value * (prev.siteWiFi?.pricePerUnit || 0)) * (prev.siteWiFi?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Cost Per Unit">
            <InputNumber
              controls={false}
              min={0}
              precision={2}
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              disabled={!selectedDefaultItems.siteWiFi}
              value={
                newBidData?.siteWiFi?.pricePerUnit
                  ? newBidData?.siteWiFi?.pricePerUnit
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  siteWiFi: {
                    ...prev.siteWiFi,
                    pricePerUnit: value,
                  },
                  salesTax: (() => {
                    if (!prev.siteWiFi?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.siteWiFi?.margin || 0) + (prev.siteWiFi?.quantity || 0) * (prev.siteWiFi?.pricePerUnit || 0)) * (prev.siteWiFi?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.siteWiFi?.margin || 0) + (prev.siteWiFi?.quantity || 0) * value) * (prev.siteWiFi?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Total Margin ($)">
            <InputNumber
              controls={false}
              min={0}
              disabled={!selectedDefaultItems.siteWiFi}
              value={
                newBidData?.siteWiFi?.margin
                  ? newBidData?.siteWiFi?.margin
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  siteWiFi: {
                    ...prev.siteWiFi,
                    margin: value,
                  },
                  salesTax: (() => {
                    if (!prev.siteWiFi?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.siteWiFi?.margin || 0) + (prev.siteWiFi?.quantity || 0) * (prev.siteWiFi?.pricePerUnit || 0)) * (prev.siteWiFi?.salesTaxPercent || 0) / 100;
                    const newTax = (value + (prev.siteWiFi?.quantity || 0) * (prev.siteWiFi?.pricePerUnit || 0)) * (prev.siteWiFi?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
            <span
              style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}
            >
              Margin % applied on Total Price:
              <b
                style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}
              >
                {newBidData?.siteWiFi?.quantity &&
                  newBidData?.siteWiFi?.margin
                  ? (
                    (newBidData?.siteWiFi?.margin /
                      (newBidData.siteWiFi.quantity *
                        newBidData.siteWiFi.pricePerUnit +
                        newBidData?.siteWiFi?.margin)) *
                    100
                  ).toFixed(2)
                  : "0.0"}{" "}
                %
              </b>
            </span>
          </Form.Item>
          <div>
            <Form.Item label="Is sales tax applicable?" valuePropName="checked">
              <Switch onChange={(checked) => {
                let newBidDataValue = {...newBidData}
                newBidDataValue.siteWiFi.salesTaxApplicable = checked
                newBidDataValue.siteWiFi.salesTaxPercent = checked ? newBidData.salesTaxPercent : 0
                setNewBidData((prev) => ({
                  ...prev,
                  siteWiFi: {
                    ...prev.siteWiFi,
                    salesTaxApplicable: checked,
                    salesTaxPercent: checked ? newBidData.salesTaxPercent : 0,
                  },
                  salesTax: checked ? handleSalesTaxPercentChange(newBidData.salesTaxPercent, newBidDataValue) : (prev.salesTax || 0) - (((prev.siteWiFi?.margin || 0) + (prev.siteWiFi?.quantity || 0) * (prev.siteWiFi?.pricePerUnit || 0)) * (newBidData.salesTaxPercent || 0) / 100),
                }));
              }}
              checked={newBidData?.siteWiFi?.salesTaxApplicable}
            />
            </Form.Item>
            {false && <Form.Item label="Sales Tax Percent">
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <InputNumber
                  controls={false}
                  min={0}
                  max={100}
                  disabled={!selectedDefaultItems.siteWiFi || !newBidData?.siteWiFi?.salesTaxApplicable}
                  value={newBidData?.siteWiFi?.salesTaxPercent ? newBidData?.siteWiFi?.salesTaxPercent : 0}
                  onChange={(value) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      siteWiFi: {
                        ...prev.siteWiFi,
                        salesTaxPercent: value
                      },
                      salesTax: (() => {
                        if (!prev.siteWiFi?.salesTaxApplicable) return prev.salesTax || 0;
                        const oldTax = ((prev.siteWiFi?.margin || 0) + (prev.siteWiFi?.quantity || 0) * (prev.siteWiFi?.pricePerUnit || 0)) * (prev.siteWiFi?.salesTaxPercent || 0) / 100;
                        const newTax = ((prev.siteWiFi?.margin || 0) + (prev.siteWiFi?.quantity || 0) * (prev.siteWiFi?.pricePerUnit || 0)) * (value || 0) / 100;
                        return (prev.salesTax || 0) - oldTax + newTax;
                      })(),
                    }));
                  }}
                />
                <span style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}>
                  {newBidData?.siteWiFi?.salesTaxApplicable
                    ? <>
                        Total Sales Tax Amount:
                        <b style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}>
                          ${(newBidData?.siteWiFi?.salesTaxPercent *
                            ((newBidData?.siteWiFi?.quantity *
                              newBidData?.siteWiFi?.pricePerUnit) + newBidData?.siteWiFi?.margin)
                            / 100 || 0).toFixed(2)}
                        </b>
                      </>
                    : "Sales Tax: Not applicable"}
                </span>
              </div>
            </Form.Item>}
          </div>
          <div className={styles.priceContainer}>
            Price per item:{" "}
            <b>
              {newBidData?.siteWiFi?.quantity &&
                newBidData?.siteWiFi?.pricePerUnit
                ? `$${(
                  (newBidData.siteWiFi.quantity *
                    newBidData.siteWiFi.pricePerUnit +
                    newBidData?.siteWiFi?.margin) *
                  (1 + (newBidData?.siteWiFi?.salesTaxPercent || 0) / 100) /
                  newBidData?.siteWiFi?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Price per item (excl. tax):{" "}
            <b>
              {newBidData?.siteWiFi?.quantity &&
                newBidData?.siteWiFi?.pricePerUnit
                ? `$${(
                  (newBidData.siteWiFi.quantity *
                    newBidData.siteWiFi.pricePerUnit +
                    (newBidData?.siteWiFi?.margin || 0)) /
                  newBidData?.siteWiFi?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price:{" "}
            <b>
              {newBidData?.siteWiFi?.quantity &&
                newBidData?.siteWiFi?.pricePerUnit
                ? `$${(
                  (newBidData.siteWiFi.quantity *
                  newBidData.siteWiFi.pricePerUnit +
                  newBidData?.siteWiFi?.margin) *
                  (1 + (newBidData?.siteWiFi?.salesTaxPercent || 0) / 100)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price (excl. tax):{" "}
            <b>
              {newBidData?.siteWiFi?.quantity &&
                newBidData?.siteWiFi?.pricePerUnit
                ? `$${(
                  newBidData.siteWiFi.quantity *
                  newBidData.siteWiFi.pricePerUnit +
                  (newBidData?.siteWiFi?.margin || 0)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          </div>
          </div>
        </div>

        {/* Wifi and antenna */}

        <div className={styles["l2-charger-form"]}>
          <Title level={5}>BreatheEV Wi-Fi</Title>

          <Form.Item>
            <Checkbox
              checked={selectedDefaultItems.wifiAntenna}
              onChange={(e) => {
                handleCheckedFieldAddToBid(
                  "wifiAntenna",
                  e.target.checked
                );
              }}
            >
              Add to Bid
            </Checkbox>
          </Form.Item>

          <div className={selectedDefaultItems.wifiAntenna ? styles.contentDivOpen : styles.contentDiv}>
            <div className={styles.contentInner}>

          <Form.Item label="Title">
            <Input
              value={
                newBidData?.wifiAntenna?.title
                  ? newBidData?.wifiAntenna?.title
                  : ""
              }
              disabled={!selectedDefaultItems.wifiAntenna}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  wifiAntenna: {
                    ...prev.wifiAntenna,
                    title: e.target.value,
                  },
                }));
              }}
            ></Input>
          </Form.Item>

          <Form.Item label="Description">
            <Input.TextArea
              value={
                newBidData?.wifiAntenna?.description
                  ? newBidData?.wifiAntenna?.description
                  : ""
              }
              disabled={!selectedDefaultItems.wifiAntenna}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  wifiAntenna: {
                    ...prev.wifiAntenna,
                    description: e.target.value,
                  },
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Quantity">
            <InputNumber
              controls={false}
              min={0}
              value={
                newBidData?.wifiAntenna?.quantity
                  ? newBidData?.wifiAntenna?.quantity
                  : 0
              }
              disabled={!selectedDefaultItems.wifiAntenna}
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  wifiAntenna: {
                    ...prev.wifiAntenna,
                    quantity: value,
                  },
                  salesTax: (() => {
                    if (!prev.wifiAntenna?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.wifiAntenna?.margin || 0) + (prev.wifiAntenna?.quantity || 0) * (prev.wifiAntenna?.pricePerUnit || 0)) * (prev.wifiAntenna?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.wifiAntenna?.margin || 0) + value * (prev.wifiAntenna?.pricePerUnit || 0)) * (prev.wifiAntenna?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Cost Per Unit">
            <InputNumber
              controls={false}
              min={0}
              precision={2}
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              disabled={!selectedDefaultItems.wifiAntenna}
              value={
                newBidData?.wifiAntenna?.pricePerUnit
                  ? newBidData?.wifiAntenna?.pricePerUnit
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  wifiAntenna: {
                    ...prev.wifiAntenna,
                    pricePerUnit: value,
                  },
                  salesTax: (() => {
                    if (!prev.wifiAntenna?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.wifiAntenna?.margin || 0) + (prev.wifiAntenna?.quantity || 0) * (prev.wifiAntenna?.pricePerUnit || 0)) * (prev.wifiAntenna?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.wifiAntenna?.margin || 0) + (prev.wifiAntenna?.quantity || 0) * value) * (prev.wifiAntenna?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Total Margin ($)">
            <InputNumber
              controls={false}
              min={0}
              disabled={!selectedDefaultItems.wifiAntenna}
              value={
                newBidData?.wifiAntenna?.margin
                  ? newBidData?.wifiAntenna?.margin
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  wifiAntenna: {
                    ...prev.wifiAntenna,
                    margin: value,
                  },
                  salesTax: (() => {
                    if (!prev.wifiAntenna?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.wifiAntenna?.margin || 0) + (prev.wifiAntenna?.quantity || 0) * (prev.wifiAntenna?.pricePerUnit || 0)) * (prev.wifiAntenna?.salesTaxPercent || 0) / 100;
                    const newTax = (value + (prev.wifiAntenna?.quantity || 0) * (prev.wifiAntenna?.pricePerUnit || 0)) * (prev.wifiAntenna?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
            <span
              style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}
            >
              Margin % applied on Total Price:
              <b
                style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}
              >
                {newBidData?.wifiAntenna?.quantity &&
                  newBidData?.wifiAntenna?.margin
                  ? (
                    (newBidData?.wifiAntenna?.margin /
                      (newBidData.wifiAntenna.quantity *
                        newBidData.wifiAntenna.pricePerUnit +
                        newBidData?.wifiAntenna?.margin)) *
                    100
                  ).toFixed(2)
                  : "0.0"}{" "}
                %
              </b>
            </span>
          </Form.Item>
          <div>
            <Form.Item label="Is sales tax applicable?" valuePropName="checked">
              <Switch onChange={(checked) => {
                let newBidDataValue = {...newBidData}
                newBidDataValue.wifiAntenna.salesTaxApplicable = checked
                newBidDataValue.wifiAntenna.salesTaxPercent = checked ? newBidData.salesTaxPercent : 0
                setNewBidData((prev) => ({
                  ...prev,
                  wifiAntenna: {
                    ...prev.wifiAntenna,
                    salesTaxApplicable: checked,
                    salesTaxPercent: checked ? newBidData.salesTaxPercent : 0,
                  },
                  salesTax: checked ? handleSalesTaxPercentChange(newBidData.salesTaxPercent, newBidDataValue) : (prev.salesTax || 0) - (((prev.wifiAntenna?.margin || 0) + (prev.wifiAntenna?.quantity || 0) * (prev.wifiAntenna?.pricePerUnit || 0)) * (newBidData.salesTaxPercent || 0) / 100),
                }));
              }}
              checked={newBidData?.wifiAntenna?.salesTaxApplicable}
              />
            </Form.Item>
            {false && <Form.Item label="Sales Tax Percent">
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <InputNumber
                  controls={false}
                  min={0}
                  max={100}
                  disabled={!selectedDefaultItems.wifiAntenna || !newBidData?.wifiAntenna?.salesTaxApplicable}
                  value={newBidData?.wifiAntenna?.salesTaxPercent ? newBidData?.wifiAntenna?.salesTaxPercent : 0}
                  onChange={(value) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      wifiAntenna: {
                        ...prev.wifiAntenna,
                        salesTaxPercent: value
                      },
                      salesTax: (() => {
                        if (!prev.wifiAntenna?.salesTaxApplicable) return prev.salesTax || 0;
                        const oldTax = ((prev.wifiAntenna?.margin || 0) + (prev.wifiAntenna?.quantity || 0) * (prev.wifiAntenna?.pricePerUnit || 0)) * (prev.wifiAntenna?.salesTaxPercent || 0) / 100;
                        const newTax = ((prev.wifiAntenna?.margin || 0) + (prev.wifiAntenna?.quantity || 0) * (prev.wifiAntenna?.pricePerUnit || 0)) * (value || 0) / 100;
                        return (prev.salesTax || 0) - oldTax + newTax;
                      })(),
                    }));
                  }}
                />
                <span style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}>
                  {newBidData?.wifiAntenna?.salesTaxApplicable
                    ? <>
                        Total Sales Tax Amount:
                        <b style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}>
                          ${(newBidData?.wifiAntenna?.salesTaxPercent *
                            ((newBidData?.wifiAntenna?.quantity *
                              newBidData?.wifiAntenna?.pricePerUnit) + newBidData?.wifiAntenna?.margin)
                            / 100 || 0).toFixed(2)}
                        </b>
                      </>
                    : "Sales Tax: Not applicable"}
                </span>
              </div>
            </Form.Item>}
          </div>
          <div className={styles.priceContainer}>
            Price per item:{" "}
            <b>
              {newBidData?.wifiAntenna?.quantity &&
                newBidData?.wifiAntenna?.pricePerUnit
                ? `$${(
                  (newBidData.wifiAntenna.quantity *
                    newBidData.wifiAntenna.pricePerUnit +
                    newBidData?.wifiAntenna?.margin) *
                  (1 + (newBidData?.wifiAntenna?.salesTaxPercent || 0) / 100) /
                  newBidData?.wifiAntenna?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Price per item (excl. tax):{" "}
            <b>
              {newBidData?.wifiAntenna?.quantity &&
                newBidData?.wifiAntenna?.pricePerUnit
                ? `$${(
                  (newBidData.wifiAntenna.quantity *
                    newBidData.wifiAntenna.pricePerUnit +
                    (newBidData?.wifiAntenna?.margin || 0)) /
                  newBidData?.wifiAntenna?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price:{" "}
            <b>
              {newBidData?.wifiAntenna?.quantity &&
                newBidData?.wifiAntenna?.pricePerUnit
                ? `$${(
                  (newBidData.wifiAntenna.quantity *
                  newBidData.wifiAntenna.pricePerUnit +
                  newBidData?.wifiAntenna?.margin) *
                  (1 + (newBidData?.wifiAntenna?.salesTaxPercent || 0) / 100)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price (excl. tax):{" "}
            <b>
              {newBidData?.wifiAntenna?.quantity &&
                newBidData?.wifiAntenna?.pricePerUnit
                ? `$${(
                  newBidData.wifiAntenna.quantity *
                  newBidData.wifiAntenna.pricePerUnit +
                  (newBidData?.wifiAntenna?.margin || 0)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          </div>
          </div>
        </div>


        {/* Breathe Ev connectivity  */}
        <div className={styles["l2-charger-form"]}>
          <Title level={5}>BreatheEV Network Connectivity</Title>

          <Form.Item>
            <Checkbox
              checked={selectedDefaultItems.wifiConnectivity}
              onChange={(e) => {
                handleCheckedFieldAddToBid(
                  "wifiConnectivity",
                  e.target.checked
                );
              }}
            >
              Add to Bid
            </Checkbox>
          </Form.Item>

          <div className={selectedDefaultItems.wifiConnectivity ? styles.contentDivOpen : styles.contentDiv}>
            <div className={styles.contentInner}>

          <Form.Item label="Title">
            <Input
              value={
                newBidData?.wifiConnectivity?.title
                  ? newBidData?.wifiConnectivity?.title
                  : ""
              }
              disabled={!selectedDefaultItems.wifiConnectivity}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  wifiConnectivity: {
                    ...prev.wifiConnectivity,
                    title: e.target.value,
                  },
                }));
              }}
            ></Input>
          </Form.Item>

          <Form.Item label="Description">
            <Input.TextArea
              value={
                newBidData?.wifiConnectivity?.description
                  ? newBidData?.wifiConnectivity?.description
                  : ""
              }
              disabled={!selectedDefaultItems.wifiConnectivity}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  wifiConnectivity: {
                    ...prev.wifiConnectivity,
                    description: e.target.value,
                  },
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Quantity">
            <InputNumber
              controls={false}
              min={0}
              value={
                newBidData?.wifiConnectivity?.quantity
                  ? newBidData?.wifiConnectivity?.quantity
                  : 0
              }
              disabled={!selectedDefaultItems.wifiConnectivity}
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  wifiConnectivity: {
                    ...prev.wifiConnectivity,
                    quantity: value,
                  },
                  salesTax: (() => {
                    if (!prev.wifiConnectivity?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.wifiConnectivity?.margin || 0) + (prev.wifiConnectivity?.quantity || 0) * (prev.wifiConnectivity?.pricePerUnit || 0)) * (prev.wifiConnectivity?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.wifiConnectivity?.margin || 0) + value * (prev.wifiConnectivity?.pricePerUnit || 0)) * (prev.wifiConnectivity?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Cost Per Unit">
            <InputNumber
              controls={false}
              min={0}
              precision={2}
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              disabled={!selectedDefaultItems.wifiConnectivity}
              value={
                newBidData?.wifiConnectivity?.pricePerUnit
                  ? newBidData?.wifiConnectivity?.pricePerUnit
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  wifiConnectivity: {
                    ...prev.wifiConnectivity,
                    pricePerUnit: value,
                  },
                  salesTax: (() => {
                    if (!prev.wifiConnectivity?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.wifiConnectivity?.margin || 0) + (prev.wifiConnectivity?.quantity || 0) * (prev.wifiConnectivity?.pricePerUnit || 0)) * (prev.wifiConnectivity?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.wifiConnectivity?.margin || 0) + (prev.wifiConnectivity?.quantity || 0) * value) * (prev.wifiConnectivity?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Total Margin ($)">
            <InputNumber
              controls={false}
              min={0}
              disabled={!selectedDefaultItems.wifiConnectivity}
              value={
                newBidData?.wifiConnectivity?.margin
                  ? newBidData?.wifiConnectivity?.margin
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  wifiConnectivity: {
                    ...prev.wifiConnectivity,
                    margin: value,
                  },
                  salesTax: (() => {
                    if (!prev.wifiConnectivity?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.wifiConnectivity?.margin || 0) + (prev.wifiConnectivity?.quantity || 0) * (prev.wifiConnectivity?.pricePerUnit || 0)) * (prev.wifiConnectivity?.salesTaxPercent || 0) / 100;
                    const newTax = (value + (prev.wifiConnectivity?.quantity || 0) * (prev.wifiConnectivity?.pricePerUnit || 0)) * (prev.wifiConnectivity?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
            <span
              style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}
            >
              Margin % applied on Total Price:
              <b
                style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}
              >
                {newBidData?.wifiConnectivity?.quantity &&
                  newBidData?.wifiConnectivity?.margin
                  ? (
                    (newBidData?.wifiConnectivity?.margin /
                      (newBidData.wifiConnectivity.quantity *
                        newBidData.wifiConnectivity.pricePerUnit +
                        newBidData?.wifiConnectivity?.margin)) *
                    100
                  ).toFixed(2)
                  : "0.0"}{" "}
                %
              </b>
            </span>
          </Form.Item>
          <div>
            <Form.Item label="Is sales tax applicable?" valuePropName="checked">
              <Switch onChange={(checked) => {
                let newBidDataValue = {...newBidData}
                newBidDataValue.wifiConnectivity.salesTaxApplicable = checked
                newBidDataValue.wifiConnectivity.salesTaxPercent = checked ? newBidData.salesTaxPercent : 0
                setNewBidData((prev) => ({
                  ...prev,
                  wifiConnectivity: {
                    ...prev.wifiConnectivity,
                    salesTaxApplicable: checked,
                    salesTaxPercent: checked ? newBidData.salesTaxPercent : 0,
                  },
                  salesTax: checked ? handleSalesTaxPercentChange(newBidData.salesTaxPercent, newBidDataValue) : (prev.salesTax || 0) - (((prev.wifiConnectivity?.margin || 0) + (prev.wifiConnectivity?.quantity || 0) * (prev.wifiConnectivity?.pricePerUnit || 0)) * (newBidData.salesTaxPercent || 0) / 100),
                }));
              }}
              checked={newBidData?.wifiConnectivity?.salesTaxApplicable}
              />
            </Form.Item>
            {false && <Form.Item label="Sales Tax Percent">
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <InputNumber
                  controls={false}
                  min={0}
                  max={100}
                  disabled={!selectedDefaultItems.wifiConnectivity || !newBidData?.wifiConnectivity?.salesTaxApplicable}
                  value={newBidData?.wifiConnectivity?.salesTaxPercent ? newBidData?.wifiConnectivity?.salesTaxPercent : 0}
                  onChange={(value) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      wifiConnectivity: {
                        ...prev.wifiConnectivity,
                        salesTaxPercent: value
                      },
                      salesTax: (() => {
                        if (!prev.wifiConnectivity?.salesTaxApplicable) return prev.salesTax || 0;
                        const oldTax = ((prev.wifiConnectivity?.margin || 0) + (prev.wifiConnectivity?.quantity || 0) * (prev.wifiConnectivity?.pricePerUnit || 0)) * (prev.wifiConnectivity?.salesTaxPercent || 0) / 100;
                        const newTax = ((prev.wifiConnectivity?.margin || 0) + (prev.wifiConnectivity?.quantity || 0) * (prev.wifiConnectivity?.pricePerUnit || 0)) * (value || 0) / 100;
                        return (prev.salesTax || 0) - oldTax + newTax;
                      })(),
                    }));
                  }}
                />
                <span style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}>
                  {newBidData?.wifiConnectivity?.salesTaxApplicable
                    ? <>
                        Total Sales Tax Amount:
                        <b style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}>
                          ${(newBidData?.wifiConnectivity?.salesTaxPercent *
                            ((newBidData?.wifiConnectivity?.quantity *
                              newBidData?.wifiConnectivity?.pricePerUnit) + newBidData?.wifiConnectivity?.margin)
                            / 100 || 0).toFixed(2)}
                        </b>
                      </>
                    : "Sales Tax: Not applicable"}
                </span>
              </div>
            </Form.Item>}
          </div>
          <div className={styles.priceContainer}>
            Price per item:{" "}
            <b>
              {newBidData?.wifiConnectivity?.quantity &&
                newBidData?.wifiConnectivity?.pricePerUnit
                ? `$${(
                  (newBidData.wifiConnectivity.quantity *
                    newBidData.wifiConnectivity.pricePerUnit +
                    newBidData?.wifiConnectivity?.margin) *
                  (1 + (newBidData?.wifiConnectivity?.salesTaxPercent || 0) / 100) /
                  newBidData?.wifiConnectivity?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Price per item (excl. tax):{" "}
            <b>
              {newBidData?.wifiConnectivity?.quantity &&
                newBidData?.wifiConnectivity?.pricePerUnit
                ? `$${(
                  (newBidData.wifiConnectivity.quantity *
                    newBidData.wifiConnectivity.pricePerUnit +
                    (newBidData?.wifiConnectivity?.margin || 0)) /
                  newBidData?.wifiConnectivity?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price:{" "}
            <b>
              {newBidData?.wifiConnectivity?.quantity &&
                newBidData?.wifiConnectivity?.pricePerUnit
                ? `$${(
                  (newBidData.wifiConnectivity.quantity *
                  newBidData.wifiConnectivity.pricePerUnit +
                  newBidData?.wifiConnectivity?.margin) *
                  (1 + (newBidData?.wifiConnectivity?.salesTaxPercent || 0) / 100)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price (excl. tax):{" "}
            <b>
              {newBidData?.wifiConnectivity?.quantity &&
                newBidData?.wifiConnectivity?.pricePerUnit
                ? `$${(
                  newBidData.wifiConnectivity.quantity *
                  newBidData.wifiConnectivity.pricePerUnit +
                  (newBidData?.wifiConnectivity?.margin || 0)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          </div>
          </div>
        </div>

        {/* simCard4G  */}
        <div className={styles["l2-charger-form"]}>
          <Title level={5}>4G Sim Card</Title>

          <Form.Item>
            <Checkbox
              checked={selectedDefaultItems.simCard4G}
              onChange={(e) => {
                handleCheckedFieldAddToBid("simCard4G", e.target.checked);
              }}
            >
              Add to Bid
            </Checkbox>
          </Form.Item>

          <div className={selectedDefaultItems.simCard4G ? styles.contentDivOpen : styles.contentDiv}>
            <div className={styles.contentInner}>

          <Form.Item label="Title">
            <Input
              value={
                newBidData?.simCard4G?.title ? newBidData?.simCard4G?.title : ""
              }
              disabled={!selectedDefaultItems.simCard4G}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  simCard4G: {
                    ...prev.simCard4G,
                    title: e.target.value,
                  },
                }));
              }}
            ></Input>
          </Form.Item>

          <Form.Item label="Description">
            <Input.TextArea
              value={
                newBidData?.simCard4G?.description
                  ? newBidData?.simCard4G?.description
                  : ""
              }
              disabled={!selectedDefaultItems.simCard4G}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  simCard4G: {
                    ...prev.simCard4G,
                    description: e.target.value,
                  },
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Quantity">
            <InputNumber
              controls={false}
              min={0}
              value={
                newBidData?.simCard4G?.quantity
                  ? newBidData?.simCard4G?.quantity
                  : 0
              }
              disabled={!selectedDefaultItems.simCard4G}
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  simCard4G: {
                    ...prev.simCard4G,
                    quantity: value,
                  },
                  salesTax: (() => {
                    if (!prev.simCard4G?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.simCard4G?.margin || 0) + (prev.simCard4G?.quantity || 0) * (prev.simCard4G?.pricePerUnit || 0)) * (prev.simCard4G?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.simCard4G?.margin || 0) + value * (prev.simCard4G?.pricePerUnit || 0)) * (prev.simCard4G?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Cost Per Unit">
            <InputNumber
              controls={false}
              min={0}
              precision={2}
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              disabled={!selectedDefaultItems.simCard4G}
              value={
                newBidData?.simCard4G?.pricePerUnit
                  ? newBidData?.simCard4G?.pricePerUnit
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  simCard4G: {
                    ...prev.simCard4G,
                    pricePerUnit: value,
                  },
                  salesTax: (() => {
                    if (!prev.simCard4G?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.simCard4G?.margin || 0) + (prev.simCard4G?.quantity || 0) * (prev.simCard4G?.pricePerUnit || 0)) * (prev.simCard4G?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.simCard4G?.margin || 0) + (prev.simCard4G?.quantity || 0) * value) * (prev.simCard4G?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Total Margin ($)">
            <InputNumber
              controls={false}
              min={0}
              disabled={!selectedDefaultItems.simCard4G}
              value={
                newBidData?.simCard4G?.margin
                  ? newBidData?.simCard4G?.margin
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  simCard4G: {
                    ...prev.simCard4G,
                    margin: value,
                  },
                  salesTax: (() => {
                    if (!prev.simCard4G?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.simCard4G?.margin || 0) + (prev.simCard4G?.quantity || 0) * (prev.simCard4G?.pricePerUnit || 0)) * (prev.simCard4G?.salesTaxPercent || 0) / 100;
                    const newTax = (value + (prev.simCard4G?.quantity || 0) * (prev.simCard4G?.pricePerUnit || 0)) * (prev.simCard4G?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
            <span
              style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}
            >
              Margin % applied on Total Price:
              <b
                style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}
              >
                {newBidData?.simCard4G?.quantity &&
                  newBidData?.simCard4G?.margin
                  ? (
                    (newBidData?.simCard4G?.margin /
                      (newBidData.simCard4G.quantity *
                        newBidData.simCard4G.pricePerUnit +
                        newBidData?.simCard4G?.margin)) *
                    100
                  ).toFixed(2)
                  : "0.0"}{" "}
                %
              </b>
            </span>
          </Form.Item>
          <div>
            <Form.Item label="Is sales tax applicable?" valuePropName="checked">
              <Switch onChange={(checked) => {
                let newBidDataValue = {...newBidData}
                newBidDataValue.simCard4G.salesTaxApplicable = checked
                newBidDataValue.simCard4G.salesTaxPercent = checked ? newBidData.salesTaxPercent : 0
                setNewBidData((prev) => ({
                  ...prev,
                  simCard4G: {
                    ...prev.simCard4G,
                    salesTaxApplicable: checked,
                    salesTaxPercent: checked ? newBidData.salesTaxPercent : 0,
                  },
                  salesTax: checked ? handleSalesTaxPercentChange(newBidData.salesTaxPercent, newBidDataValue) : (prev.salesTax || 0) - (((prev.simCard4G?.margin || 0) + (prev.simCard4G?.quantity || 0) * (prev.simCard4G?.pricePerUnit || 0)) * (newBidData.salesTaxPercent || 0) / 100),
                }));
              }}
              checked={newBidData?.simCard4G?.salesTaxApplicable}
            />
            </Form.Item>
            {false && <Form.Item label="Sales Tax Percent">
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <InputNumber
                  controls={false}
                  min={0}
                  max={100}
                  disabled={!selectedDefaultItems.simCard4G || !newBidData?.simCard4G?.salesTaxApplicable}
                  value={newBidData?.simCard4G?.salesTaxPercent ? newBidData?.simCard4G?.salesTaxPercent : 0}
                  onChange={(value) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      simCard4G: {
                        ...prev.simCard4G,
                        salesTaxPercent: value
                      },
                      salesTax: (() => {
                        if (!prev.simCard4G?.salesTaxApplicable) return prev.salesTax || 0;
                        const oldTax = ((prev.simCard4G?.margin || 0) + (prev.simCard4G?.quantity || 0) * (prev.simCard4G?.pricePerUnit || 0)) * (prev.simCard4G?.salesTaxPercent || 0) / 100;
                        const newTax = ((prev.simCard4G?.margin || 0) + (prev.simCard4G?.quantity || 0) * (prev.simCard4G?.pricePerUnit || 0)) * (value || 0) / 100;
                        return (prev.salesTax || 0) - oldTax + newTax;
                      })(),
                    }));
                  }}
                />
                <span style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}>
                  {newBidData?.simCard4G?.salesTaxApplicable
                    ? <>
                        Total Sales Tax Amount:
                        <b style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}>
                          ${(newBidData?.simCard4G?.salesTaxPercent *
                            ((newBidData?.simCard4G?.quantity *
                              newBidData?.simCard4G?.pricePerUnit) + newBidData?.simCard4G?.margin)
                            / 100 || 0).toFixed(2)}
                        </b>
                      </>
                    : "Sales Tax: Not applicable"}
                </span>
              </div>
            </Form.Item>}
          </div>
          <div className={styles.priceContainer}>
            Price per item:{" "}
            <b>
              {newBidData?.simCard4G?.quantity &&
                newBidData?.simCard4G?.pricePerUnit
                ? `$${(
                  (newBidData.simCard4G.quantity *
                    newBidData.simCard4G.pricePerUnit +
                    newBidData?.simCard4G?.margin) *
                  (1 + (newBidData?.simCard4G?.salesTaxPercent || 0) / 100) /
                  newBidData?.simCard4G?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Price per item (excl. tax):{" "}
            <b>
              {newBidData?.simCard4G?.quantity &&
                newBidData?.simCard4G?.pricePerUnit
                ? `$${(
                  (newBidData.simCard4G.quantity *
                    newBidData.simCard4G.pricePerUnit +
                    (newBidData?.simCard4G?.margin || 0)) /
                  newBidData?.simCard4G?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price:{" "}
            <b>
              {newBidData?.simCard4G?.quantity &&
                newBidData?.simCard4G?.pricePerUnit
                ? `$${(
                  (newBidData.simCard4G.quantity *
                  newBidData.simCard4G.pricePerUnit +
                  newBidData?.simCard4G?.margin) *
                  (1 + (newBidData?.simCard4G?.salesTaxPercent || 0) / 100)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price (excl. tax):{" "}
            <b>
              {newBidData?.simCard4G?.quantity &&
                newBidData?.simCard4G?.pricePerUnit
                ? `$${(
                  newBidData.simCard4G.quantity *
                  newBidData.simCard4G.pricePerUnit +
                  (newBidData?.simCard4G?.margin || 0)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          </div>
          </div>
        </div>

        

        {/* warranty  */}
        <div className={styles["l2-charger-form"]}>
          <Title level={5}>Warranty</Title>

          <Form.Item>
            <Checkbox
              checked={selectedDefaultItems.warranty}
              onChange={(e) => {
                handleCheckedFieldAddToBid("warranty", e.target.checked);
              }}
            >
              Add to Bid
            </Checkbox>
          </Form.Item>

          <div className={selectedDefaultItems.warranty ? styles.contentDivOpen : styles.contentDiv}>
            <div className={styles.contentInner}>

          <Form.Item label="Title">
            <Input
              value={
                newBidData?.warranty?.title ? newBidData?.warranty?.title : ""
              }
              disabled={!selectedDefaultItems.warranty}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  warranty: {
                    ...prev.warranty,
                    title: e.target.value,
                  },
                }));
              }}
            ></Input>
          </Form.Item>

          <Form.Item label="Description">
            <Input.TextArea
              value={
                newBidData?.warranty?.description
                  ? newBidData?.warranty?.description
                  : ""
              }
              disabled={!selectedDefaultItems.warranty}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  warranty: {
                    ...prev.warranty,
                    description: e.target.value,
                  },
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Quantity">
            <InputNumber
              controls={false}
              min={0}
              value={
                newBidData?.warranty?.quantity
                  ? newBidData?.warranty?.quantity
                  : 0
              }
              disabled={!selectedDefaultItems.warranty}
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  warranty: {
                    ...prev.warranty,
                    quantity: value,
                  },
                  salesTax: (() => {
                    if (!prev.warranty?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.warranty?.margin || 0) + (prev.warranty?.quantity || 0) * (prev.warranty?.pricePerUnit || 0)) * (prev.warranty?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.warranty?.margin || 0) + value * (prev.warranty?.pricePerUnit || 0)) * (prev.warranty?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Cost Per Unit">
            <InputNumber
              controls={false}
              min={0}
              precision={2}
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              disabled={!selectedDefaultItems.warranty}
              value={
                newBidData?.warranty?.pricePerUnit
                  ? newBidData?.warranty?.pricePerUnit
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  warranty: {
                    ...prev.warranty,
                    pricePerUnit: value,
                  },
                  salesTax: (() => {
                    if (!prev.warranty?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.warranty?.margin || 0) + (prev.warranty?.quantity || 0) * (prev.warranty?.pricePerUnit || 0)) * (prev.warranty?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.warranty?.margin || 0) + (prev.warranty?.quantity || 0) * value) * (prev.warranty?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Total Margin ($)">
            <InputNumber
              controls={false}
              min={0}
              disabled={!selectedDefaultItems.warranty}
              value={
                newBidData?.warranty?.margin ? newBidData?.warranty?.margin : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  warranty: {
                    ...prev.warranty,
                    margin: value,
                  },
                  salesTax: (() => {
                    if (!prev.warranty?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.warranty?.margin || 0) + (prev.warranty?.quantity || 0) * (prev.warranty?.pricePerUnit || 0)) * (prev.warranty?.salesTaxPercent || 0) / 100;
                    const newTax = (value + (prev.warranty?.quantity || 0) * (prev.warranty?.pricePerUnit || 0)) * (prev.warranty?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
            <span
              style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}
            >
              Margin % applied on Total Price:
              <b
                style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}
              >
                {newBidData?.warranty?.quantity && newBidData?.warranty?.margin
                  ? (
                    (newBidData?.warranty?.margin /
                      (newBidData.warranty.quantity *
                        newBidData.warranty.pricePerUnit +
                        newBidData?.warranty?.margin)) *
                    100
                  ).toFixed(2)
                  : "0.0"}{" "}
                %
              </b>
            </span>
          </Form.Item>
          <div>
            <Form.Item label="Is sales tax applicable?" valuePropName="checked">
              <Switch onChange={(checked) => {
                let newBidDataValue = {...newBidData}
                newBidDataValue.warranty.salesTaxApplicable = checked
                newBidDataValue.warranty.salesTaxPercent = checked ? newBidData.salesTaxPercent : 0
                setNewBidData((prev) => ({
                  ...prev,
                  warranty: {
                    ...prev.warranty,
                    salesTaxApplicable: checked,
                    salesTaxPercent: checked ? newBidData.salesTaxPercent : 0,
                  },
                  salesTax: checked ? handleSalesTaxPercentChange(newBidData.salesTaxPercent, newBidDataValue) : (prev.salesTax || 0) - (((prev.warranty?.margin || 0) + (prev.warranty?.quantity || 0) * (prev.warranty?.pricePerUnit || 0)) * (newBidData.salesTaxPercent || 0) / 100),
                }));
              }}
              checked={newBidData?.warranty?.salesTaxApplicable}
              />
            </Form.Item>
            {false && <Form.Item label="Sales Tax Percent">
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <InputNumber
                  controls={false}
                  min={0}
                  max={100}
                  disabled={!selectedDefaultItems.warranty || !newBidData?.warranty?.salesTaxApplicable}
                  value={newBidData?.warranty?.salesTaxPercent ? newBidData?.warranty?.salesTaxPercent : 0}
                  onChange={(value) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      warranty: {
                        ...prev.warranty,
                        salesTaxPercent: value
                      },
                      salesTax: (() => {
                        if (!prev.warranty?.salesTaxApplicable) return prev.salesTax || 0;
                        const oldTax = ((prev.warranty?.margin || 0) + (prev.warranty?.quantity || 0) * (prev.warranty?.pricePerUnit || 0)) * (prev.warranty?.salesTaxPercent || 0) / 100;
                        const newTax = ((prev.warranty?.margin || 0) + (prev.warranty?.quantity || 0) * (prev.warranty?.pricePerUnit || 0)) * (value || 0) / 100;
                        return (prev.salesTax || 0) - oldTax + newTax;
                      })(),
                    }));
                  }}
                />
                <span style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}>
                  {newBidData?.warranty?.salesTaxApplicable
                    ? <>
                        Total Sales Tax Amount:
                        <b style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}>
                          ${(newBidData?.warranty?.salesTaxPercent *
                            ((newBidData?.warranty?.quantity *
                              newBidData?.warranty?.pricePerUnit) + newBidData?.warranty?.margin)
                            / 100 || 0).toFixed(2)}
                        </b>
                      </>
                    : "Sales Tax: Not applicable"}
                </span>
              </div>
            </Form.Item>}
          </div>
          <div className={styles.priceContainer}>
            Price per item:{" "}
            <b>
              {newBidData?.warranty?.quantity &&
                newBidData?.warranty?.pricePerUnit
                ? `$${(
                  (newBidData.warranty.quantity *
                    newBidData.warranty.pricePerUnit +
                    newBidData?.warranty?.margin) *
                  (1 + (newBidData?.warranty?.salesTaxPercent || 0) / 100) /
                  newBidData?.warranty?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Price per item (excl. tax):{" "}
            <b>
              {newBidData?.warranty?.quantity &&
                newBidData?.warranty?.pricePerUnit
                ? `$${(
                  (newBidData.warranty.quantity *
                    newBidData.warranty.pricePerUnit +
                    (newBidData?.warranty?.margin || 0)) /
                  newBidData?.warranty?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price:{" "}
            <b>
              {newBidData?.warranty?.quantity &&
                newBidData?.warranty?.pricePerUnit
                ? `$${(
                  (newBidData.warranty.quantity *
                  newBidData.warranty.pricePerUnit +
                  newBidData?.warranty?.margin) *
                  (1 + (newBidData?.warranty?.salesTaxPercent || 0) / 100)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price (excl. tax):{" "}
            <b>
              {newBidData?.warranty?.quantity &&
                newBidData?.warranty?.pricePerUnit
                ? `$${(
                  newBidData.warranty.quantity *
                  newBidData.warranty.pricePerUnit +
                  (newBidData?.warranty?.margin || 0)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          </div>
          </div>
        </div>

        

        {/* signage */}
        <div className={styles["l2-charger-form"]}>
          <Title level={5}>Signage</Title>

          <Form.Item>
            <Checkbox
              checked={selectedDefaultItems.signage}
              onChange={(e) => {
                handleCheckedFieldAddToBid("signage", e.target.checked);
              }}
            >
              Add to Bid
            </Checkbox>
          </Form.Item>

          <div className={selectedDefaultItems.signage ? styles.contentDivOpen : styles.contentDiv}>
            <div className={styles.contentInner}>

          <Form.Item label="Title">
            <Input
              value={
                newBidData?.signage?.title ? newBidData?.signage?.title : ""
              }
              disabled={!selectedDefaultItems.signage}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  signage: {
                    ...prev.signage,
                    title: e.target.value,
                  },
                }));
              }}
            ></Input>
          </Form.Item>

          <Form.Item label="Description">
            <Input.TextArea
              value={
                newBidData?.signage?.description
                  ? newBidData?.signage?.description
                  : ""
              }
              disabled={!selectedDefaultItems.signage}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  signage: {
                    ...prev.signage,
                    description: e.target.value,
                  },
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Quantity">
            <InputNumber
              controls={false}
              min={0}
              value={
                newBidData?.signage?.quantity
                  ? newBidData?.signage?.quantity
                  : 0
              }
              disabled={!selectedDefaultItems.signage}
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  signage: {
                    ...prev.signage,
                    quantity: value,
                  },
                  salesTax: (() => {
                    if (!prev.signage?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.signage?.margin || 0) + (prev.signage?.quantity || 0) * (prev.signage?.pricePerUnit || 0)) * (prev.signage?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.signage?.margin || 0) + value * (prev.signage?.pricePerUnit || 0)) * (prev.signage?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Cost Per Unit">
            <InputNumber
              controls={false}
              min={0}
              precision={2}
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              disabled={!selectedDefaultItems.signage}
              value={
                newBidData?.signage?.pricePerUnit
                  ? newBidData?.signage?.pricePerUnit
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  signage: {
                    ...prev.signage,
                    pricePerUnit: value,
                  },
                  salesTax: (() => {
                    if (!prev.signage?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.signage?.margin || 0) + (prev.signage?.quantity || 0) * (prev.signage?.pricePerUnit || 0)) * (prev.signage?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.signage?.margin || 0) + (prev.signage?.quantity || 0) * value) * (prev.signage?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Total Margin ($)">
            <InputNumber
              controls={false}
              min={0}
              disabled={!selectedDefaultItems.signage}
              value={
                newBidData?.signage?.margin ? newBidData?.signage?.margin : ""
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  signage: {
                    ...prev.signage,
                    margin: value,
                  },
                  salesTax: (() => {
                    if (!prev.signage?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.signage?.margin || 0) + (prev.signage?.quantity || 0) * (prev.signage?.pricePerUnit || 0)) * (prev.signage?.salesTaxPercent || 0) / 100;
                    const newTax = (value + (prev.signage?.quantity || 0) * (prev.signage?.pricePerUnit || 0)) * (prev.signage?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
            <span
              style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}
            >
              Margin % applied on Total Price:
              <b
                style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}
              >
                {newBidData?.signage?.quantity && newBidData?.signage?.margin
                  ? (
                    (newBidData?.signage?.margin /
                      (newBidData.signage.quantity *
                        newBidData.signage.pricePerUnit +
                        newBidData?.signage?.margin)) *
                    100
                  ).toFixed(2)
                  : "0.0"}{" "}
                %
              </b>
            </span>
          </Form.Item>
          <div>
            <Form.Item label="Is sales tax applicable?" valuePropName="checked">
              <Switch onChange={(checked) => {
                let newBidDataValue = {...newBidData}
                newBidDataValue.signage.salesTaxApplicable = checked
                newBidDataValue.signage.salesTaxPercent = checked ? newBidData.salesTaxPercent : 0
                setNewBidData((prev) => ({
                  ...prev,
                  signage: {
                    ...prev.signage,
                    salesTaxApplicable: checked,
                    salesTaxPercent: checked ? newBidData.salesTaxPercent : 0,
                  },
                  salesTax: checked ? handleSalesTaxPercentChange(newBidData.salesTaxPercent, newBidDataValue) : (prev.salesTax || 0) - (((prev.signage?.margin || 0) + (prev.signage?.quantity || 0) * (prev.signage?.pricePerUnit || 0)) * (newBidData.salesTaxPercent || 0) / 100),
                }));
              }}
              checked ={newBidData?.signage?.salesTaxApplicable}
              />
            </Form.Item>
            {false && <Form.Item label="Sales Tax Percent">
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <InputNumber
                  controls={false}
                  min={0}
                  max={100}
                  disabled={!selectedDefaultItems.signage || !newBidData?.signage?.salesTaxApplicable}
                  value={newBidData?.signage?.salesTaxPercent ? newBidData?.signage?.salesTaxPercent : 0}
                  onChange={(value) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      signage: {
                        ...prev.signage,
                        salesTaxPercent: value
                      },
                      salesTax: (() => {
                        if (!prev.signage?.salesTaxApplicable) return prev.salesTax || 0;
                        const oldTax = ((prev.signage?.margin || 0) + (prev.signage?.quantity || 0) * (prev.signage?.pricePerUnit || 0)) * (prev.signage?.salesTaxPercent || 0) / 100;
                        const newTax = ((prev.signage?.margin || 0) + (prev.signage?.quantity || 0) * (prev.signage?.pricePerUnit || 0)) * (value || 0) / 100;
                        return (prev.salesTax || 0) - oldTax + newTax;
                      })(),
                    }));
                  }}
                />
                <span style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}>
                  {newBidData?.signage?.salesTaxApplicable
                    ? <>
                        Total Sales Tax Amount:
                        <b style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}>
                          ${(newBidData?.signage?.salesTaxPercent *
                            ((newBidData?.signage?.quantity *
                              newBidData?.signage?.pricePerUnit) + newBidData?.signage?.margin)
                            / 100 || 0).toFixed(2)}
                        </b>
                      </>
                    : "Sales Tax: Not applicable"}
                </span>
              </div>
            </Form.Item>}
          </div>
          <div className={styles.priceContainer}>
            Price per item:{" "}
            <b>
              {newBidData?.signage?.quantity &&
                newBidData?.signage?.pricePerUnit
                ? `$${(
                  (newBidData.signage.quantity *
                    newBidData.signage.pricePerUnit +
                    newBidData?.signage?.margin) *
                  (1 + (newBidData?.signage?.salesTaxPercent || 0) / 100) /
                  newBidData?.signage?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Price per item (excl. tax):{" "}
            <b>
              {newBidData?.signage?.quantity &&
                newBidData?.signage?.pricePerUnit
                ? `$${(
                  (newBidData.signage.quantity *
                    newBidData.signage.pricePerUnit +
                    (newBidData?.signage?.margin || 0)) /
                  newBidData?.signage?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price:{" "}
            <b>
              {newBidData?.signage?.quantity &&
                newBidData?.signage?.pricePerUnit
                ? `$${(
                  (newBidData.signage.quantity *
                  newBidData.signage.pricePerUnit +
                  newBidData?.signage?.margin) *
                  (1 + (newBidData?.signage?.salesTaxPercent || 0) / 100)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price (excl. tax):{" "}
            <b>
              {newBidData?.signage?.quantity &&
                newBidData?.signage?.pricePerUnit
                ? `$${(
                  newBidData.signage.quantity *
                  newBidData.signage.pricePerUnit +
                  (newBidData?.signage?.margin || 0)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          </div>
          </div>
        </div>

        {/* pedestals  */}
        <div className={styles["l2-charger-form"]}>
          <Title level={5}>Pedestal</Title>

          <Form.Item>
            <Checkbox
              checked={selectedDefaultItems.pedestals}
              onChange={(e) => {
                handleCheckedFieldAddToBid("pedestals", e.target.checked);
              }}
            >
              Add to Bid
            </Checkbox>
          </Form.Item>

          <div className={selectedDefaultItems.pedestals ? styles.contentDivOpen : styles.contentDiv}>
            <div className={styles.contentInner}>

          <Form.Item label="Title">
            <Input
              value={
                newBidData?.pedestals?.title ? newBidData?.pedestals?.title : ""
              }
              disabled={!selectedDefaultItems.pedestals}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  pedestals: {
                    ...prev.pedestals,
                    title: e.target.value,
                  },
                }));
              }}
            ></Input>
          </Form.Item>

          <Form.Item label="Description">
            <Input.TextArea
              value={
                newBidData?.pedestals?.description
                  ? newBidData?.pedestals?.description
                  : ""
              }
              disabled={!selectedDefaultItems.pedestals}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  pedestals: {
                    ...prev.pedestals,
                    description: e.target.value,
                  },
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Quantity">
            <InputNumber
              controls={false}
              min={0}
              value={
                newBidData?.pedestals?.quantity
                  ? newBidData?.pedestals?.quantity
                  : 0
              }
              disabled={!selectedDefaultItems.pedestals}
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  pedestals: {
                    ...prev.pedestals,
                    quantity: value,
                  },
                  salesTax: (() => {
                    if (!prev.pedestals?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.pedestals?.margin || 0) + (prev.pedestals?.quantity || 0) * (prev.pedestals?.pricePerUnit || 0)) * (prev.pedestals?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.pedestals?.margin || 0) + value * (prev.pedestals?.pricePerUnit || 0)) * (prev.pedestals?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Cost Per Unit">
            <InputNumber
              controls={false}
              min={0}
              precision={2}
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              disabled={!selectedDefaultItems.pedestals}
              value={
                newBidData?.pedestals?.pricePerUnit
                  ? newBidData?.pedestals?.pricePerUnit
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  pedestals: {
                    ...prev.pedestals,
                    pricePerUnit: value,
                  },
                  salesTax: (() => {
                    if (!prev.pedestals?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.pedestals?.margin || 0) + (prev.pedestals?.quantity || 0) * (prev.pedestals?.pricePerUnit || 0)) * (prev.pedestals?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.pedestals?.margin || 0) + (prev.pedestals?.quantity || 0) * value) * (prev.pedestals?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Total Margin ($)">
            <InputNumber
              controls={false}
              min={0}
              disabled={!selectedDefaultItems.pedestals}
              value={
                newBidData?.pedestals?.margin
                  ? newBidData?.pedestals?.margin
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  pedestals: {
                    ...prev.pedestals,
                    margin: value,
                  },
                  salesTax: (() => {
                    if (!prev.pedestals?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.pedestals?.margin || 0) + (prev.pedestals?.quantity || 0) * (prev.pedestals?.pricePerUnit || 0)) * (prev.pedestals?.salesTaxPercent || 0) / 100;
                    const newTax = (value + (prev.pedestals?.quantity || 0) * (prev.pedestals?.pricePerUnit || 0)) * (prev.pedestals?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
            <span
              style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}
            >
              Margin % applied on Total Price:
              <b
                style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}
              >
                {newBidData?.pedestals?.quantity &&
                  newBidData?.pedestals?.margin
                  ? (
                    (newBidData?.pedestals?.margin /
                      (newBidData.pedestals.quantity *
                        newBidData.pedestals.pricePerUnit +
                        newBidData?.pedestals?.margin)) *
                    100
                  ).toFixed(2)
                  : "0.0"}{" "}
                %
              </b>
            </span>
          </Form.Item>
          <div>
            <Form.Item label="Is sales tax applicable?" valuePropName="checked">
              <Switch onChange={(checked) => {
                let newBidDataValue = {...newBidData}
                newBidDataValue.pedestals.salesTaxApplicable = checked
                newBidDataValue.pedestals.salesTaxPercent = checked ? newBidData.salesTaxPercent : 0
                setNewBidData((prev) => ({
                  ...prev,
                  pedestals: {
                    ...prev.pedestals,
                    salesTaxApplicable: checked,
                    salesTaxPercent: checked ? newBidData.salesTaxPercent : 0,
                  },
                  salesTax: checked ? handleSalesTaxPercentChange(newBidData.salesTaxPercent, newBidDataValue) : (prev.salesTax || 0) - (((prev.pedestals?.margin || 0) + (prev.pedestals?.quantity || 0) * (prev.pedestals?.pricePerUnit || 0)) * (newBidData.salesTaxPercent || 0) / 100),
                }));
              }}
              checked={newBidData?.pedestals?.salesTaxApplicable}
            />
            </Form.Item>
            {false && <Form.Item label="Sales Tax Percent">
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <InputNumber
                  controls={false}
                  min={0}
                  max={100}
                  disabled={!selectedDefaultItems.pedestals || !newBidData?.pedestals?.salesTaxApplicable}
                  value={newBidData?.pedestals?.salesTaxPercent ? newBidData?.pedestals?.salesTaxPercent : 0}
                  onChange={(value) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      pedestals: {
                        ...prev.pedestals,
                        salesTaxPercent: value
                      },
                      salesTax: (() => {
                        if (!prev.pedestals?.salesTaxApplicable) return prev.salesTax || 0;
                        const oldTax = ((prev.pedestals?.margin || 0) + (prev.pedestals?.quantity || 0) * (prev.pedestals?.pricePerUnit || 0)) * (prev.pedestals?.salesTaxPercent || 0) / 100;
                        const newTax = ((prev.pedestals?.margin || 0) + (prev.pedestals?.quantity || 0) * (prev.pedestals?.pricePerUnit || 0)) * (value || 0) / 100;
                        return (prev.salesTax || 0) - oldTax + newTax;
                      })(),
                    }));
                  }}
                />
                <span style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}>
                  {newBidData?.pedestals?.salesTaxApplicable
                    ? <>
                        Total Sales Tax Amount:
                        <b style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}>
                          ${(newBidData?.pedestals?.salesTaxPercent *
                            ((newBidData?.pedestals?.quantity *
                              newBidData?.pedestals?.pricePerUnit) + newBidData?.pedestals?.margin)
                            / 100 || 0).toFixed(2)}
                        </b>
                      </>
                    : "Sales Tax: Not applicable"}
                </span>
              </div>
            </Form.Item>}
          </div>
          <div className={styles.priceContainer}>
            Price per item:{" "}
            <b>
              {newBidData?.pedestals?.quantity &&
                newBidData?.pedestals?.pricePerUnit
                ? `$${(
                  (newBidData.pedestals.quantity *
                    newBidData.pedestals.pricePerUnit +
                    newBidData?.pedestals?.margin) *
                  (1 + (newBidData?.pedestals?.salesTaxPercent || 0) / 100) /
                  newBidData?.pedestals?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Price per item (excl. tax):{" "}
            <b>
              {newBidData?.pedestals?.quantity &&
                newBidData?.pedestals?.pricePerUnit
                ? `$${(
                  (newBidData.pedestals.quantity *
                    newBidData.pedestals.pricePerUnit +
                    (newBidData?.pedestals?.margin || 0)) /
                  newBidData?.pedestals?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price:{" "}
            <b>
              {newBidData?.pedestals?.quantity &&
                newBidData?.pedestals?.pricePerUnit
                ? `$${(
                  (newBidData.pedestals.quantity *
                  newBidData.pedestals.pricePerUnit +
                  newBidData?.pedestals?.margin) *
                  (1 + (newBidData?.pedestals?.salesTaxPercent || 0) / 100)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price (excl. tax):{" "}
            <b>
              {newBidData?.pedestals?.quantity &&
                newBidData?.pedestals?.pricePerUnit
                ? `$${(
                  newBidData.pedestals.quantity *
                  newBidData.pedestals.pricePerUnit +
                  (newBidData?.pedestals?.margin || 0)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          </div>
          </div>
        </div>
 


        {/* shipping */}
        <div className={styles["l2-charger-form"]}>
          <Title level={5}>Shipping & Handling</Title>

          <Form.Item>
            <Checkbox
              checked={selectedDefaultItems.shipping}
              onChange={(e) => {
                handleCheckedFieldAddToBid("shipping", e.target.checked);
              }}
            >
              Add to Bid
            </Checkbox>
          </Form.Item>

          <div className={selectedDefaultItems.shipping ? styles.contentDivOpen : styles.contentDiv}>
            <div className={styles.contentInner}>

          <Form.Item label="Title">
            <Input
              value={
                newBidData?.shipping?.title ? newBidData?.shipping?.title : ""
              }
              disabled={!selectedDefaultItems.shipping}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  shipping: {
                    ...prev.shipping,
                    title: e.target.value,
                  },
                }));
              }}
            ></Input>
          </Form.Item>

          <Form.Item label="Description">
            <Input.TextArea
              value={
                newBidData?.shipping?.description
                  ? newBidData?.shipping?.description
                  : ""
              }
              disabled={!selectedDefaultItems.shipping}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  shipping: {
                    ...prev.shipping,
                    description: e.target.value,
                  },
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Quantity">
            <InputNumber
              controls={false}
              min={0}
              value={
                newBidData?.shipping?.quantity
                  ? newBidData?.shipping?.quantity
                  : 0
              }
              disabled={!selectedDefaultItems.shipping}
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  shipping: {
                    ...prev.shipping,
                    quantity: value,
                  },
                  salesTax: (() => {
                    if (!prev.shipping?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.shipping?.margin || 0) + (prev.shipping?.quantity || 0) * (prev.shipping?.pricePerUnit || 0)) * (prev.shipping?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.shipping?.margin || 0) + value * (prev.shipping?.pricePerUnit || 0)) * (prev.shipping?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Cost Per Unit">
            <InputNumber
              controls={false}
              min={0}
              precision={2}
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              disabled={!selectedDefaultItems.shipping}
              value={
                newBidData?.shipping?.pricePerUnit
                  ? newBidData?.shipping?.pricePerUnit
                  : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  shipping: {
                    ...prev.shipping,
                    pricePerUnit: value,
                  },
                  salesTax: (() => {
                    if (!prev.shipping?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.shipping?.margin || 0) + (prev.shipping?.quantity || 0) * (prev.shipping?.pricePerUnit || 0)) * (prev.shipping?.salesTaxPercent || 0) / 100;
                    const newTax = ((prev.shipping?.margin || 0) + (prev.shipping?.quantity || 0) * value) * (prev.shipping?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
          </Form.Item>

          <Form.Item label="Total Margin ($)">
            <InputNumber
              controls={false}
              min={0}
              disabled={!selectedDefaultItems.shipping}
              value={
                newBidData?.shipping?.margin ? newBidData?.shipping?.margin : 0
              }
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  shipping: {
                    ...prev.shipping,
                    margin: value,
                  },
                  salesTax: (() => {
                    if (!prev.shipping?.salesTaxApplicable) return prev.salesTax || 0;
                    const oldTax = ((prev.shipping?.margin || 0) + (prev.shipping?.quantity || 0) * (prev.shipping?.pricePerUnit || 0)) * (prev.shipping?.salesTaxPercent || 0) / 100;
                    const newTax = (value + (prev.shipping?.quantity || 0) * (prev.shipping?.pricePerUnit || 0)) * (prev.shipping?.salesTaxPercent || 0) / 100;
                    return (prev.salesTax || 0) - oldTax + newTax;
                  })(),
                }));
              }}
            />
            <span
              style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}
            >
              Margin % applied on Total Price:
              <b
                style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}
              >
                {newBidData?.shipping?.quantity && newBidData?.shipping?.margin
                  ? (
                    (newBidData?.shipping?.margin /
                      (newBidData.shipping.quantity *
                        newBidData.shipping.pricePerUnit +
                        newBidData?.shipping?.margin)) *
                    100
                  ).toFixed(2)
                  : "0.0"}{" "}
                %
              </b>
            </span>
          </Form.Item>
          <div>
            <Form.Item label="Is sales tax applicable?" valuePropName="checked">
              <Switch onChange={(checked) => {
                let newBidDataValue = {...newBidData}
                newBidDataValue.shipping.salesTaxApplicable = checked
                newBidDataValue.shipping.salesTaxPercent = checked ? newBidData.salesTaxPercent : 0
                setNewBidData((prev) => ({
                  ...prev,
                  shipping: {
                    ...prev.shipping,
                    salesTaxApplicable: checked,
                    salesTaxPercent: checked ? newBidData.salesTaxPercent : 0,
                  },
                  salesTax: checked ? handleSalesTaxPercentChange(newBidData.salesTaxPercent, newBidDataValue) : (prev.salesTax || 0) - (((prev.shipping?.margin || 0) + (prev.shipping?.quantity || 0) * (prev.shipping?.pricePerUnit || 0)) * (newBidData.salesTaxPercent || 0) / 100),
                }));
              }}
              checked={newBidData?.shipping?.salesTaxApplicable}
              />
            </Form.Item>
            {false && <Form.Item label="Sales Tax Percent">
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <InputNumber
                  controls={false}
                  min={0}
                  max={100}
                  disabled={!selectedDefaultItems.shipping || !newBidData?.shipping?.salesTaxApplicable}
                  value={newBidData?.shipping?.salesTaxPercent ? newBidData?.shipping?.salesTaxPercent : 0}
                  onChange={(value) => {
                    setNewBidData((prev) => ({
                      ...prev,
                      shipping: {
                        ...prev.shipping,
                        salesTaxPercent: value
                      },
                      salesTax: (() => {
                        if (!prev.shipping?.salesTaxApplicable) return prev.salesTax || 0;
                        const oldTax = ((prev.shipping?.margin || 0) + (prev.shipping?.quantity || 0) * (prev.shipping?.pricePerUnit || 0)) * (prev.shipping?.salesTaxPercent || 0) / 100;
                        const newTax = ((prev.shipping?.margin || 0) + (prev.shipping?.quantity || 0) * (prev.shipping?.pricePerUnit || 0)) * (value || 0) / 100;
                        return (prev.salesTax || 0) - oldTax + newTax;
                      })(),
                    }));
                  }}
                />
                <span style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}>
                  {newBidData?.shipping?.salesTaxApplicable
                    ? <>
                        Total Sales Tax Amount:
                        <b style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}>
                          ${(newBidData?.shipping?.salesTaxPercent *
                            ((newBidData?.shipping?.quantity *
                              newBidData?.shipping?.pricePerUnit) + newBidData?.shipping?.margin)
                            / 100 || 0).toFixed(2)}
                        </b>
                      </>
                    : "Sales Tax: Not applicable"}
                </span>
              </div>
            </Form.Item>}
          </div>
          <div className={styles.priceContainer}>
            Price per item:{" "}
            <b>
              {newBidData?.shipping?.quantity &&
                newBidData?.shipping?.pricePerUnit
                ? `$${(
                  (newBidData.shipping.quantity *
                    newBidData.shipping.pricePerUnit +
                    newBidData?.shipping?.margin) *
                  (1 + (newBidData?.shipping?.salesTaxPercent || 0) / 100) /
                  newBidData?.shipping?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Price per item (excl. tax):{" "}
            <b>
              {newBidData?.shipping?.quantity &&
                newBidData?.shipping?.pricePerUnit
                ? `$${(
                  (newBidData.shipping.quantity *
                    newBidData.shipping.pricePerUnit +
                    (newBidData?.shipping?.margin || 0)) /
                  newBidData?.shipping?.quantity
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price:{" "}
            <b>
              {newBidData?.shipping?.quantity &&
                newBidData?.shipping?.pricePerUnit
                ? `$${(
                  (newBidData.shipping.quantity *
                  newBidData.shipping.pricePerUnit +
                  newBidData?.shipping?.margin) *
                  (1 + (newBidData?.shipping?.salesTaxPercent || 0) / 100)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          <div className={styles.priceContainer}>
            Total Price (excl. tax):{" "}
            <b>
              {newBidData?.shipping?.quantity &&
                newBidData?.shipping?.pricePerUnit
                ? `$${(
                  newBidData.shipping.quantity *
                  newBidData.shipping.pricePerUnit +
                  (newBidData?.shipping?.margin || 0)
                ).toFixed(2)}`
                : "$0.00"}
            </b>
          </div>
          </div>
          </div>
        </div>

        <div className={styles["l2-charger-form"]}>
          {/* <Title level={5}></Title> */}
          <Form.Item
            label="Payment Type"
            rules={[{ required: true, message: "Please select format" }]}
          >
            <Select
              onClick={(e) => e.stopPropagation()}
              value={newBidData.paymentType}
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  paymentType: value,
                  termsAndConditions: value === "FullPayment" ? InitialtermsAndConditionsForFullPayment : InitialtermsAndConditions
                }))
              }

              }
              placeholder="Select payment type"
            >
              <Select.Option Option value="FullPayment">FullPayment</Select.Option>
              <Select.Option value="PartPayment">PartPayment</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="Terms and Conditions: ">
            <Input.TextArea
              value={
                newBidData?.termsAndConditions
                  ? newBidData?.termsAndConditions
                  : ""
              }
              autoSize={true}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  termsAndConditions: e.target.value,
                }));
              }}
            />
          </Form.Item>
          <Form.Item label="Description: ">
            <Input.TextArea
              value={
                newBidData?.customDescription
                  ? newBidData?.customDescription
                  : ""
              }
              autoSize={true}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  customDescription: e.target.value,
                }));
              }}
            />
          </Form.Item>
        </div>

        <div className={styles["l2-charger-form"]}>
          {/* className={styles.counter} */}
          Add Custom Field:
          <button
            type="button"
            // className={styles.counterButton}
            onClick={() => {
              setCount((prevCount) => {
                const newCount = prevCount - 1;
                if (newCount >= 0) {
                  setNewBidData((prev) => ({
                    ...prev,
                    bidCustomData: prev.bidCustomData.slice(0, newCount), // Remove last connector
                  }));
                }
                return newCount;
              });
            }}
            disabled={count <= 0}
          >
            -
          </button>
          {count}
          <button
            type="button"
            // className={styles.counterButton}
            onClick={() => {
              setCount((prevCount) => {
                const newCount = prevCount + 1;

                setNewBidData((prev) => ({
                  ...prev,
                  bidCustomData: [
                    ...prev.bidCustomData,
                    {
                      fieldTitle: "",
                      fieldDescription: "",
                      fieldPricePerUnit: 0,
                      fieldQuantity: 0,
                      fieldMargin: 0,
                      fieldsalesTaxApplicable: false,
                      fieldsalesTaxPercent: 0,
                    },
                  ],
                }));

                return newCount;
              });
            }}
          >
            +
          </button>
        </div>

        {Array.from({ length: count }).map((_, index) => (
          <div key={index}>
            {
              <div
                onClick={(e) => e.stopPropagation()} // Prevent click from propagating to parent div
              >
                <Title level={5}>Custom Field {index + 1}</Title>

                <Form.Item label="Name">
                  <Input
                    style={{ width: "100%" }}
                    value={newBidData?.bidCustomData[index]?.fieldTitle}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) =>
                      handleCustomFieldChange(
                        index,
                        "fieldTitle",
                        e.target.value
                      )
                    }
                  />
                </Form.Item>

                <Form.Item label="Description">
                  <Input
                    style={{ width: "100%" }}
                    value={newBidData?.bidCustomData[index]?.fieldDescription}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) =>
                      handleCustomFieldChange(
                        index,
                        "fieldDescription",
                        e.target.value
                      )
                    }
                  />
                </Form.Item>

                <Form.Item label="Cost Per Unit">
                  <InputNumber
                    controls={false}
                    min={0}
                    precision={2}
                    style={{ width: "100%" }}
                    formatter={(value) =>
                      `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(value) => {
                      setNewBidData((prev) => {
                        const updatedCustomData = [...prev.bidCustomData];
                        updatedCustomData[index] = { ...updatedCustomData[index], fieldPricePerUnit: value };
                        const item = prev.bidCustomData[index];
                        if (!item?.fieldsalesTaxApplicable) return { ...prev, bidCustomData: updatedCustomData };
                        const oldTax = ((item?.fieldMargin || 0) + (item?.fieldQuantity || 0) * (item?.fieldPricePerUnit || 0)) * (item?.fieldsalesTaxPercent || 0) / 100;
                        const newTax = ((item?.fieldMargin || 0) + (item?.fieldQuantity || 0) * value) * (item?.fieldsalesTaxPercent || 0) / 100;
                        return { ...prev, bidCustomData: updatedCustomData, salesTax: (prev.salesTax || 0) - oldTax + newTax };
                      });
                    }}
                    value={newBidData?.bidCustomData[index]?.fieldPricePerUnit}
                  />
                </Form.Item>

                <Form.Item label="Quantity">
                  <InputNumber
                    controls={false}
                    min={0}
                    style={{ width: "100%" }}
                    value={newBidData?.bidCustomData[index]?.fieldQuantity}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(value) => {
                      setNewBidData((prev) => {
                        const updatedCustomData = [...prev.bidCustomData];
                        updatedCustomData[index] = { ...updatedCustomData[index], fieldQuantity: value };
                        const item = prev.bidCustomData[index];
                        if (!item?.fieldsalesTaxApplicable) return { ...prev, bidCustomData: updatedCustomData };
                        const oldTax = ((item?.fieldMargin || 0) + (item?.fieldQuantity || 0) * (item?.fieldPricePerUnit || 0)) * (item?.fieldsalesTaxPercent || 0) / 100;
                        const newTax = ((item?.fieldMargin || 0) + value * (item?.fieldPricePerUnit || 0)) * (item?.fieldsalesTaxPercent || 0) / 100;
                        return { ...prev, bidCustomData: updatedCustomData, salesTax: (prev.salesTax || 0) - oldTax + newTax };
                      });
                    }}
                  />
                </Form.Item>

                <Form.Item label="Total Margin ($)">
                  <InputNumber
                    controls={false}
                    min={0}
                    style={{ width: "100%" }}
                    value={newBidData?.bidCustomData[index]?.fieldMargin}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(value) => {
                      setNewBidData((prev) => {
                        const updatedCustomData = [...prev.bidCustomData];
                        updatedCustomData[index] = { ...updatedCustomData[index], fieldMargin: value };
                        const item = prev.bidCustomData[index];
                        if (!item?.fieldsalesTaxApplicable) return { ...prev, bidCustomData: updatedCustomData };
                        const oldTax = ((item?.fieldMargin || 0) + (item?.fieldQuantity || 0) * (item?.fieldPricePerUnit || 0)) * (item?.fieldsalesTaxPercent || 0) / 100;
                        const newTax = (value + (item?.fieldQuantity || 0) * (item?.fieldPricePerUnit || 0)) * (item?.fieldsalesTaxPercent || 0) / 100;
                        return { ...prev, bidCustomData: updatedCustomData, salesTax: (prev.salesTax || 0) - oldTax + newTax };
                      });
                    }}
                  />
                  <span
                    style={{
                      fontSize: "12px",
                      color: "gray",
                      marginLeft: "10px",
                    }}
                  >
                    Margin % applied on Total Price:
                    <b
                      style={{
                        fontSize: "15px",
                        color: "green",
                        marginLeft: "10px",
                      }}
                    >
                      {newBidData?.bidCustomData[index]?.fieldQuantity &&
                        newBidData?.bidCustomData[index]?.fieldMargin
                        ? (
                          (newBidData?.bidCustomData[index]?.fieldMargin /
                            (newBidData.bidCustomData[index].fieldQuantity *
                              newBidData.bidCustomData[index]
                                .fieldPricePerUnit +
                              newBidData?.bidCustomData[index]
                                ?.fieldMargin)) *
                          100
                        ).toFixed(2)
                        : "0.0"}{" "}
                      %
                    </b>
                  </span>
                </Form.Item>
                <div>
                  <Form.Item label="Is sales tax applicable?" valuePropName="checked">
                    <Switch onChange={(checked) => {
                      let newBidDataValue = {...newBidData}
                      newBidDataValue.bidCustomData[index].fieldsalesTaxApplicable = checked
                      newBidDataValue.bidCustomData[index].fieldsalesTaxPercent = checked ? newBidData.salesTaxPercent : 0
                      setNewBidData((prev) => {
                        const updatedCustomData = [...prev.bidCustomData];
                        const item = prev.bidCustomData[index];
                        updatedCustomData[index] = {
                          ...item, 
                          fieldsalesTaxApplicable: checked,
                          fieldsalesTaxPercent: checked ? newBidData.salesTaxPercent : 0, 
                        };
                        // const deductedTax = checked ? 0 : (((item?.fieldMargin || 0) + (item?.fieldQuantity || 0) * (item?.fieldPricePerUnit || 0)) * (newBidData.salesTaxPercent || 0) / 100);
                        return { ...prev, bidCustomData: updatedCustomData, 
                          // salesTax: (prev.salesTax || 0) - deductedTax 
                          salesTax: checked ? handleSalesTaxPercentChange(newBidData.salesTaxPercent, newBidDataValue) : (prev.salesTax || 0) - (((item?.fieldMargin || 0) + (item?.fieldQuantity || 0) * (item?.fieldPricePerUnit || 0)) * (newBidData.salesTaxPercent || 0) / 100)
                        };
                      });
                    }}
                    checked={newBidData?.bidCustomData[index]?.fieldsalesTaxApplicable}
                    />
                  </Form.Item>
                  {false && <Form.Item label="Sales Tax Percent">
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <InputNumber
                        controls={false}
                        min={0}
                        max={100}
                        disabled={!newBidData?.bidCustomData[index]?.fieldsalesTaxApplicable}
                        value={newBidData?.bidCustomData[index]?.fieldsalesTaxPercent || 0}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(value) => {
                          setNewBidData((prev) => {
                            const updatedCustomData = [...prev.bidCustomData];
                            const item = prev.bidCustomData[index];
                            updatedCustomData[index] = { ...item, fieldsalesTaxPercent: value };
                            if (!item?.fieldsalesTaxApplicable) return { ...prev, bidCustomData: updatedCustomData };
                            const oldTax = ((item?.fieldMargin || 0) + (item?.fieldQuantity || 0) * (item?.fieldPricePerUnit || 0)) * (item?.fieldsalesTaxPercent || 0) / 100;
                            const newTax = ((item?.fieldMargin || 0) + (item?.fieldQuantity || 0) * (item?.fieldPricePerUnit || 0)) * (value || 0) / 100;
                            return { ...prev, bidCustomData: updatedCustomData, salesTax: (prev.salesTax || 0) - oldTax + newTax };
                          });
                        }}
                      />
                      <span style={{ fontSize: "12px", color: "gray", marginLeft: "10px" }}>
                        {newBidData?.bidCustomData[index]?.fieldsalesTaxApplicable
                          ? <>
                              Total Sales Tax Amount:
                              <b style={{ fontSize: "15px", color: "green", marginLeft: "10px" }}>
                                ${(newBidData?.bidCustomData[index]?.fieldsalesTaxPercent *
                                  ((newBidData?.bidCustomData[index]?.fieldQuantity *
                                    newBidData?.bidCustomData[index]?.fieldPricePerUnit) +
                                      newBidData?.bidCustomData[index]?.fieldMargin)
                                  / 100 || 0).toFixed(2)}
                              </b>
                            </>
                          : "Sales Tax: Not applicable"}
                      </span>
                    </div>
                  </Form.Item>}
                </div>
                <div className={styles.priceContainer}>
                  Price per item:{" "}
                  <b>
                    {newBidData?.bidCustomData[index]?.fieldQuantity &&
                      newBidData?.bidCustomData[index]?.fieldPricePerUnit
                      ? `$${(
                        ((newBidData.bidCustomData[index].fieldQuantity *
                          newBidData.bidCustomData[index].fieldPricePerUnit +
                          newBidData?.bidCustomData[index]?.fieldMargin) * (1 + (newBidData?.bidCustomData[index]?.fieldsalesTaxPercent || 0) / 100)) /
                        newBidData?.bidCustomData[index]?.fieldQuantity
                      ).toFixed(2)}`
                      : "$0.00"}
                  </b>
                </div>
                <div className={styles.priceContainer}>
                  Price per item (excl. tax):{" "}
                  <b>
                    {newBidData?.bidCustomData[index]?.fieldQuantity &&
                      newBidData?.bidCustomData[index]?.fieldPricePerUnit
                      ? `$${(
                        (newBidData.bidCustomData[index].fieldQuantity *
                          newBidData.bidCustomData[index].fieldPricePerUnit +
                          (newBidData?.bidCustomData[index]?.fieldMargin || 0)) /
                        newBidData?.bidCustomData[index]?.fieldQuantity
                      ).toFixed(2)}`
                      : "$0.00"}
                  </b>
                </div>
                <div className={styles.priceContainer}>
                  Total Price:{" "}
                  <b>
                    {newBidData?.bidCustomData[index]?.fieldQuantity &&
                      newBidData?.bidCustomData[index]?.fieldPricePerUnit
                      ? `$${(
                        ((newBidData.bidCustomData[index].fieldQuantity *
                        newBidData.bidCustomData[index].fieldPricePerUnit) +
                        newBidData?.bidCustomData[index]?.fieldMargin) * (1 + (newBidData?.bidCustomData[index]?.fieldsalesTaxPercent || 0) / 100)
                      ).toFixed(2)}`
                      : "$0.00"}
                  </b>
                </div>
                <div className={styles.priceContainer}>
                  Total Price (excl. tax):{" "}
                  <b>
                    {newBidData?.bidCustomData[index]?.fieldQuantity &&
                      newBidData?.bidCustomData[index]?.fieldPricePerUnit
                      ? `$${(
                        newBidData.bidCustomData[index].fieldQuantity *
                        newBidData.bidCustomData[index].fieldPricePerUnit +
                        (newBidData?.bidCustomData[index]?.fieldMargin || 0)
                      ).toFixed(2)}`
                      : "$0.00"}
                  </b>
                </div>
              </div>
            }
          </div>
        ))}

        <hr></hr>

        <p className={styles["create-bid-subtotal"]}>
          Subtotal:{" "}
          <b className={styles["create-bid-amount-values"]}>$ {subTotalCost}</b>
        </p>
        <div className={styles["l2-charger-form"]}>
          <Checkbox checked={rebateChecked} onChange={(e) => handleRebateChange(e.target.checked)}>Rebate</Checkbox>
          <Form.Item>
            <Input
              disabled={!rebateChecked}
              value={newBidData?.rebateTitle ? newBidData?.rebateTitle : ""}
              onChange={(e) => {
                setNewBidData((prev) => ({
                  ...prev,
                  rebateTitle: e.target.value,
                }));
              }}
            ></Input>
          </Form.Item>
          <Form.Item label="Rebate Amount">
            <InputNumber
              controls={false}
              disabled={!rebateChecked}
              min={0}
              value={newBidData?.rebateAmount ? newBidData?.rebateAmount : 0}
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  rebateAmount: value,
                }));
              }}
            />
          </Form.Item>
          <Form.Item label="Sales Tax ($)">
            {console.log("new bid data in sales tax amount; ", newBidData)}
            <InputNumber
              controls={false}
              min={0}
              value={newBidData?.salesTax ? Number(newBidData?.salesTax).toFixed(2) : 0}
              onChange={(value) => {
                setNewBidData((prev) => ({
                  ...prev,
                  salesTax: value,
                }));
              }}
              disabled={true}
            />
          </Form.Item>
          <Form.Item label="Sales Tax (%)">
            <InputNumber
              controls={false}
              min={0}
              placeholder="sales tax %"
              value={
                newBidData?.salesTaxPercent ? (!Number.isInteger(newBidData?.salesTaxPercent) ? newBidData?.salesTaxPercent.toFixed(2): newBidData?.salesTaxPercent) : 0
              }
              onChange={(value) => {
                // setNewBidData((prev) => ({
                //   ...prev,
                //   salesTaxPercent: value,
                // }));
                handleSalesTaxPercentChange(value, newBidData);
              }}
              // disabled={true}
            />
          </Form.Item>
        </div>
        <p className={styles["create-bid-subtotal"]}>
          Total Cost (Subtotal + Sales Tax - Rebate Amount):{" "}
          <b className={styles["create-bid-amount-values"]}>
            $ {totalCostAmount.toFixed(2)}{" "}
          </b>
        </p>
        <p className={styles["create-bid-subtotal"]}>
          Total Margin:{" "}
          <b className={styles["create-bid-amount-values"]}>
            $ {totalMarginCost.toFixed(2)}
          </b>
        </p>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            {!editBid ? "Create Bid" : "Update Bid"}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default CreateBid;
